
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8Hi5s", function(module, exports) {
$parcel$export(module.exports, "carouselExtensionType", () => (parcelRequire("5Ac5G")).carouselExtensionType);
$parcel$export(module.exports, "carouselExtensionKey", () => (parcelRequire("5Ac5G")).carouselExtensionKey);
$parcel$export(module.exports, "FRAMES_LIMIT_V2", () => (parcelRequire("5Ac5G")).FRAMES_LIMIT_V2);
$parcel$export(module.exports, "getExtensionNodeFromParams", () => (parcelRequire("4kqHy")).getExtensionNodeFromParams);
$parcel$export(module.exports, "mockInitialCarouselParameters", () => (parcelRequire("4kqHy")).mockInitialCarouselParameters);
$parcel$export(module.exports, "mockV2Carousel10FramesParameters", () => (parcelRequire("4kqHy")).mockV2Carousel10FramesParameters);
$parcel$export(module.exports, "CornerStyle", () => (parcelRequire("4cOi8")).CornerStyle);
$parcel$export(module.exports, "NavigationStyle", () => (parcelRequire("9Uxg8")).NavigationStyle);
$parcel$export(module.exports, "carouselExtensionProvider", () => (parcelRequire("g6QUH")).carouselExtensionProvider);
$parcel$export(module.exports, "Carousel", () => (parcelRequire("luzTT")).Carousel);
$parcel$export(module.exports, "CarouselConfigPanelContent", () => (parcelRequire("l1iRA")).CarouselConfigPanelContent);
$parcel$export(module.exports, "carouselHubElement", () => (parcelRequire("kZ6bD")).carouselHubElement);

var $5Ac5G = parcelRequire("5Ac5G");


var $4kqHy = parcelRequire("4kqHy");


var $4cOi8 = parcelRequire("4cOi8");

var $9Uxg8 = parcelRequire("9Uxg8");


var $g6QUH = parcelRequire("g6QUH");


var $luzTT = parcelRequire("luzTT");


var $l1iRA = parcelRequire("l1iRA");


var $kZ6bD = parcelRequire("kZ6bD");


});

parcelRegister("1Yx9c", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hnvzE = parcelRequire("hnvzE");


var $fOKpq = parcelRequire("fOKpq");


var $4cOi8 = parcelRequire("4cOi8");


var $1m9A2 = parcelRequire("1m9A2");


var $8Ixq2 = parcelRequire("8Ixq2");


var $jrlgF = parcelRequire("jrlgF");


var $glqE9 = parcelRequire("glqE9");

const $b3bbb984d806269d$export$1b8348eac06ebe09 = ({ extensionNode: extensionNode, contentId: contentId, analyticsAttributes: analyticsAttributes, children: children, showNoDataState: showNoDataState, mode: mode = (0, $4cOi8.ExtensionMode).RENDERER, packageName: packageName })=>{
    const { analyticsContext: analyticsContext, errorBoundaryComponent: errorBoundaryComponent, experienceStartComponent: experienceStartComponent } = (0, $fOKpq.useProductDependencies)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { extensionKey: extensionKey, parameters: parameters } = extensionNode || {};
    const hasParameters = !showNoDataState || parameters;
    const ExperienceStart = experienceStartComponent || (0, $42omo.Fragment);
    const ErrorBoundaryComponent = errorBoundaryComponent || (0, $jrlgF.HubErrorBoundary);
    const errorBoundaryProps = errorBoundaryComponent ? {} : {
        id: extensionKey ?? contentId,
        packageName: packageName,
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $8Ixq2.GenericErrorPage), {})
    };
    (0, $42omo.useEffect)(()=>{
        if (mode === (0, $4cOi8.ExtensionMode).RENDERER) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'macro',
                actionSubjectId: extensionKey,
                source: 'viewPageScreen',
                attributes: {
                    ...analyticsAttributes,
                    ...analyticsContext,
                    hasParameters: !!parameters,
                    contentId: contentId
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: extensionKey || 'unknown-hub-extension',
        children: /*#__PURE__*/ (0, $l998X.jsxs)(ErrorBoundaryComponent, {
            ...errorBoundaryProps,
            shouldForceError: (0, $glqE9.EXTENSIONS_CRITICAL_FOR_PAGE_LOAD).has(extensionKey || ''),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(ExperienceStart, {}),
                hasParameters ? children : /*#__PURE__*/ (0, $l998X.jsx)((0, $1m9A2.NoExtensionData), {
                    source: extensionKey
                })
            ]
        })
    });
};
module.exports["HubExtensionsWrapper"] = $b3bbb984d806269d$export$1b8348eac06ebe09;

});

parcelRegister("1m9A2", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hiS1z = parcelRequire("hiS1z");

var $1cfRh = parcelRequire("1cfRh");


var $1Whri = parcelRequire("1Whri");


var $abC4X = parcelRequire("abC4X");


var $gdv5Z = parcelRequire("gdv5Z");


var $fOKpq = parcelRequire("fOKpq");


var $harUV = parcelRequire("harUV");


var $dE8aF = parcelRequire("dE8aF");

const $947dafb4b85c32e6$var$styles = {
    baseStyles: "_1e0c1txw _1bah1h6o _4cvr1h6o",
    configPanelStyles: "_4t3i1vuk",
    extensionStyles: "_4t3i1osq"
};
const $947dafb4b85c32e6$export$dd91c9257a0f1cd4 = ({ source: source = '', isConfigPanel: isConfigPanel })=>{
    const intl = (0, $1cfRh.default)();
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const extensionSourceName = source?.charAt(0).toUpperCase() + source?.slice(1);
    (0, $42omo.useEffect)(()=>{
        const errorMessage = `${extensionSourceName} ${isConfigPanel ? 'config panel' : 'extension'} failed to render. No parameters.`;
        submitError?.(new Error(errorMessage));
    }, [
        extensionSourceName,
        isConfigPanel,
        submitError
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($947dafb4b85c32e6$var$styles.baseStyles, isConfigPanel ? $947dafb4b85c32e6$var$styles.configPanelStyles : $947dafb4b85c32e6$var$styles.extensionStyles),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
            header: intl.formatMessage((0, $dE8aF.messages).noDataStateHeaderText),
            description: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                ...(0, $dE8aF.messages).noDataStateDescription
            }),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($harUV)))
        })
    });
};
module.exports["NoExtensionData"] = $947dafb4b85c32e6$export$dd91c9257a0f1cd4;

});

parcelRegister("harUV", function(module, exports) {
module.exports = new URL("Warning.e56d4e3e.svg", import.meta.url).toString();

});

parcelRegister("dE8aF", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $8bb95c815845532f$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    noDataStateHeaderText: {
        id: "company-hub.company-hub-common.link-cards.error-states.no-data.header-text",
        defaultMessage: "No data to display"
    },
    noDataStateDescription: {
        id: "company-hub.company-hub-common.link-cards.error-states.no-data.description-text",
        defaultMessage: "Try deleting this macro and creating a new one."
    }
});
module.exports["messages"] = $8bb95c815845532f$export$defe85febe8b728c;

});

parcelRegister("glqE9", function(module, exports) {
// we have made a copy of the extension keys to avoid importing the constants from the extensions packages
// this is a temporary solution to avoid the bundle size increase
// todo: we will have to create a new package for the constants and import it here
const $97dcfab536b484ac$export$3617e2677e53ded6 = new Set([
    'links-menu',
    'cards',
    'spotlight',
    'carousel',
    'hub-section',
    'jsm-help'
]);
module.exports["EXTENSIONS_CRITICAL_FOR_PAGE_LOAD"] = $97dcfab536b484ac$export$3617e2677e53ded6;

});

parcelRegister("kZ6bD", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gj7hi = parcelRequire("gj7hi");


var $5Ac5G = parcelRequire("5Ac5G");


var $4dJei = parcelRequire("4dJei");

var $lKEry = parcelRequire("lKEry");


var $g6QUH = parcelRequire("g6QUH");


var $dP1Jv = parcelRequire("dP1Jv");

const $3c80b00b710c9c8f$var$getDefaultCarouselNodeAdf = (intl)=>{
    const { formatMessage: formatMessage } = intl;
    return {
        type: 'extension',
        attrs: {
            extensionKey: (0, $5Ac5G.carouselExtensionKey),
            extensionType: (0, $5Ac5G.carouselExtensionType),
            parameters: (0, $g6QUH.carouselParameters)({
                intl: intl,
                extensionTitle: formatMessage((0, $dP1Jv.messages).carouselTitle)
            })
        }
    };
};
const $3c80b00b710c9c8f$var$thumbnailImage = /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($4dJei))),
    srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($lKEry))),
    alt: ""
});
const $3c80b00b710c9c8f$export$dbd835d2c212fc57 = {
    extensionKey: (0, $5Ac5G.carouselExtensionKey),
    title: (0, $dP1Jv.messages).carouselTitle,
    description: (0, $dP1Jv.messages).carouselDescription,
    Image: $3c80b00b710c9c8f$var$thumbnailImage,
    // @todo set update lozenge to false after release https://hello.jira.atlassian.cloud/browse/COMPHUB-3150
    hasUpdatedLozenge: true,
    getNodeAdf: $3c80b00b710c9c8f$var$getDefaultCarouselNodeAdf
};
module.exports["carouselHubElement"] = $3c80b00b710c9c8f$export$dbd835d2c212fc57;

});

parcelRegister("4dJei", function(module, exports) {
module.exports = new URL("carouselHubElementThumbnail.18a104a0.svg", import.meta.url).toString();

});

parcelRegister("lKEry", function(module, exports) {
module.exports = new URL("carouselHubElementThumbnail-dark.394e0d80.svg", import.meta.url).toString();

});

parcelRegister("dP1Jv", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $afe166ffd76550b7$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    carouselTitle: {
        id: "company-hub.carousel-extension.hub-element.title",
        defaultMessage: "Carousel"
    },
    carouselDescription: {
        id: "company-hub.carousel-extension.hub-element.description",
        defaultMessage: "A rotating set of beautiful frames"
    }
});
module.exports["messages"] = $afe166ffd76550b7$export$defe85febe8b728c;

});

parcelRegister("5qzNs", function(module, exports) {

var $5ukOg = parcelRequire("5ukOg");


var $ipwYn = parcelRequire("ipwYn");


var $5kt6R = parcelRequire("5kt6R");


var $f2rYC = parcelRequire("f2rYC");


var $gR42R = parcelRequire("gR42R");


var $5baaE = parcelRequire("5baaE");


var $5Nw7l = parcelRequire("5Nw7l");


var $jHiyU = parcelRequire("jHiyU");

/** Used to compose bitmasks for cloning. */ var $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG = 1, $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG = 2, $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3f3b25eb0c07a9d2$var$omit = $5Nw7l(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $5ukOg(paths, function(path) {
        path = $f2rYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $gR42R(object, $jHiyU(object), result);
    if (isDeep) result = $ipwYn(result, $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG | $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG | $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG, $5baaE);
    var length = paths.length;
    while(length--)$5kt6R(result, paths[length]);
    return result;
});
module.exports = $3f3b25eb0c07a9d2$var$omit;

});

parcelRegister("5kt6R", function(module, exports) {

var $f2rYC = parcelRequire("f2rYC");


var $apAFY = parcelRequire("apAFY");


var $9rfkh = parcelRequire("9rfkh");


var $w287Y = parcelRequire("w287Y");

/** Used for built-in method references. */ var $3e1566926de40aab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3e1566926de40aab$var$hasOwnProperty = $3e1566926de40aab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3e1566926de40aab$var$baseUnset(object, path) {
    path = $f2rYC(path, object);
    // Prevent prototype pollution, see: https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    var index = -1, length = path.length;
    if (!length) return true;
    var isRootPrimitive = object == null || typeof object !== 'object' && typeof object !== 'function';
    while(++index < length){
        var key = path[index];
        // skip non-string keys (e.g., Symbols, numbers)
        if (typeof key !== 'string') continue;
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$3e1566926de40aab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block "constructor.prototype" chains
        if (key === 'constructor' && index + 1 < length && typeof path[index + 1] === 'string' && path[index + 1] === 'prototype') {
            // Allow ONLY when the path starts at a primitive root, e.g., _.unset(0, 'constructor.prototype.a')
            if (isRootPrimitive && index === 0) continue;
            return false;
        }
    }
    var obj = $9rfkh(object, path);
    return obj == null || delete obj[$w287Y($apAFY(path))];
}
module.exports = $3e1566926de40aab$var$baseUnset;

});

parcelRegister("9rfkh", function(module, exports) {

var $aT80v = parcelRequire("aT80v");


var $3BqCC = parcelRequire("3BqCC");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $6df28623e183fd76$var$parent(object, path) {
    return path.length < 2 ? object : $aT80v(object, $3BqCC(path, 0, -1));
}
module.exports = $6df28623e183fd76$var$parent;

});

parcelRegister("5baaE", function(module, exports) {

var $gTZCn = parcelRequire("gTZCn");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $3c55de8c787dd7a6$var$customOmitClone(value) {
    return $gTZCn(value) ? undefined : value;
}
module.exports = $3c55de8c787dd7a6$var$customOmitClone;

});

parcelRegister("5Nw7l", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $438a713c021efc47$var$flatRest(func) {
    return $gnVVm($iK2Oc(func, undefined, $5qOzM), func + '');
}
module.exports = $438a713c021efc47$var$flatRest;

});

parcelRegister("5qOzM", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f469ccb29f16086$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8jC8i(array, 1) : [];
}
module.exports = $3f469ccb29f16086$var$flatten;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("6iY4P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0e9f22edb5bbb2a5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $kXb3C = parcelRequire("kXb3C");

function $0e9f22edb5bbb2a5$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("kXb3C", function(module, exports) {
$parcel$export(module.exports, "default", () => $5412502140f64e3a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $5412502140f64e3a$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});

parcelRegister("9JsQ8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $chO1Z = parcelRequire("chO1Z");


var $7CgcZ = parcelRequire("7CgcZ");

const $b894277b0121d160$var$FileIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), 'grayBold');
$b894277b0121d160$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $b894277b0121d160$export$2e2bcd8739ae039 = $b894277b0121d160$var$FileIconWithColor;
module.exports["default"] = $b894277b0121d160$export$2e2bcd8739ae039;

});

parcelRegister("1w5AW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $1zLiv = parcelRequire("1zLiv");


var $7CgcZ = parcelRequire("7CgcZ");

const $236bd638115a684a$var$ChartBarIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($1zLiv))), 'purpleBold');
$236bd638115a684a$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $236bd638115a684a$export$2e2bcd8739ae039 = $236bd638115a684a$var$ChartBarIconWithColor;
module.exports["default"] = $236bd638115a684a$export$2e2bcd8739ae039;

});

parcelRegister("h45kr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $cUQMr = parcelRequire("cUQMr");


var $7CgcZ = parcelRequire("7CgcZ");

const $55cc43e42726cbf8$var$ListBulletedIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), 'greenBold');
$55cc43e42726cbf8$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $55cc43e42726cbf8$export$2e2bcd8739ae039 = $55cc43e42726cbf8$var$ListBulletedIconWithColor;
module.exports["default"] = $55cc43e42726cbf8$export$2e2bcd8739ae039;

});

parcelRegister("8PFSM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $009878891f6679eb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d51578aa68f6f1f67b6c4a1d4bb0368>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $iOozU = parcelRequire("iOozU");


var $kXb3C = parcelRequire("kXb3C");

function $009878891f6679eb$export$2e2bcd8739ae039({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iOozU))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("iZCav", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0686486f925c9ddd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5dc8472ed4701f1e18b170a37220fe41>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $fZeLS = parcelRequire("fZeLS");


var $kXb3C = parcelRequire("kXb3C");

function $0686486f925c9ddd$export$2e2bcd8739ae039({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fZeLS))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});

parcelRegister("5NrIb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $692c05f58e5d3ef7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4a46dfaccc0758bf1b71ccf340efb6a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $7OYaz = parcelRequire("7OYaz");


var $kXb3C = parcelRequire("kXb3C");

function $692c05f58e5d3ef7$export$2e2bcd8739ae039({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});

parcelRegister("gV3jM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2708dfe0209c3c78$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00550c5037cc26264de6baee26f7399e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eIlE7 = parcelRequire("eIlE7");


var $kXb3C = parcelRequire("kXb3C");

function $2708dfe0209c3c78$export$2e2bcd8739ae039({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("1WiZb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c77f4c6a2336f8ae$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0179ace6db90174fb1e33ede0463bdef>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4BqOc = parcelRequire("4BqOc");


var $kXb3C = parcelRequire("kXb3C");

function $c77f4c6a2336f8ae$export$2e2bcd8739ae039({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});

parcelRegister("kWiYc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4ce94c9023f0019e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d32d0479ba45c629729cf798e1abfca>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4SWbm = parcelRequire("4SWbm");


var $kXb3C = parcelRequire("kXb3C");

function $4ce94c9023f0019e$export$2e2bcd8739ae039({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("cKqka", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4b99d5ed076c1160$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46cc2c056bbd3058657958f7f09f6575>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5LN4K = parcelRequire("5LN4K");


var $kXb3C = parcelRequire("kXb3C");

function $4b99d5ed076c1160$export$2e2bcd8739ae039({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5LN4K))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("7Jxvl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ef63a9b3b9aed96b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c6870d6420a4692ac4cdb5a00753f738>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jz9js = parcelRequire("jz9js");


var $kXb3C = parcelRequire("kXb3C");

function $ef63a9b3b9aed96b$export$2e2bcd8739ae039({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jz9js))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("4KIbP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $627ab7f82241d2c9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08e9485c746db90f5ac9b367aa0dd41e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $49GPt = parcelRequire("49GPt");


var $kXb3C = parcelRequire("kXb3C");

function $627ab7f82241d2c9$export$2e2bcd8739ae039({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($49GPt))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("6Eovk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d797c8c4e4c6494$export$2e2bcd8739ae039);
/* eslint-disable import/no-default-export */ /* eslint-disable react/prop-types */ 
var $42omo = parcelRequire("42omo");


var $cMypa = parcelRequire("cMypa");

function $4d797c8c4e4c6494$export$2e2bcd8739ae039(props) {
    // Produce the image tag as is because there is no onLoad event in SSR
    // Also render image tag directly if the page was SSRed because react-render-image always render placeholder first.
    // This will make image flicker
    return props.src && window.__SSR_RENDERED__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.loaded) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMypa))), props);
}

});

parcelRegister("cMypa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94e4a7d853f8088a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $94e4a7d853f8088a$var$React = $94e4a7d853f8088a$var$_interopRequireWildcard($42omo);
function $94e4a7d853f8088a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $94e4a7d853f8088a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $94e4a7d853f8088a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $94e4a7d853f8088a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $94e4a7d853f8088a$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $94e4a7d853f8088a$var$loaded() {
    return {
        isLoaded: true
    };
}
function $94e4a7d853f8088a$var$errored() {
    return {
        isErrored: true
    };
}
function $94e4a7d853f8088a$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $94e4a7d853f8088a$var$ImageRenderer = function(_React$Component) {
    $94e4a7d853f8088a$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $94e4a7d853f8088a$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $94e4a7d853f8088a$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $94e4a7d853f8088a$var$_possibleConstructorReturn(_this, _ret);
    }
    $94e4a7d853f8088a$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(this.props, nextProps)) this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($94e4a7d853f8088a$var$React.Component);
module.exports.default = $94e4a7d853f8088a$var$ImageRenderer;

});

parcelRegister("1Okf1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDhJe = parcelRequire("dDhJe");

const $6833d9101ef67c08$export$d08617a365fbe694 = (cardClient)=>(0, $42omo.useMemo)(()=>(0, $dDhJe.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $6833d9101ef67c08$export$d08617a365fbe694;

});

parcelRegister("h982G", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");


var $i25hX = parcelRequire("i25hX");

const $a5e138d08f3fc65b$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $a5e138d08f3fc65b$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $a5e138d08f3fc65b$var$allowedSubdomains = [
    '.jira-dev.com',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $a5e138d08f3fc65b$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $a5e138d08f3fc65b$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($a5e138d08f3fc65b$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $a5e138d08f3fc65b$var$allowedOrigins.includes(hostname));
};
const $a5e138d08f3fc65b$export$e5e1a9c59c299631 = ()=>{
    const publish = (0, $i25hX.usePublish)('ai-mate');
    (0, $42omo.useEffect)(()=>{
        const handlerUnbind = (0, $fFa3V.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$a5e138d08f3fc65b$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $a5e138d08f3fc65b$export$cabfb6cc8c48b099) {
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $a5e138d08f3fc65b$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    event.source?.postMessage(ackPayload, (0, $dh538.fg)('ai-mate-pub-sub-post-message-origin-fix') ? {
                        targetOrigin: '*'
                    } : undefined);
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
const $a5e138d08f3fc65b$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $a5e138d08f3fc65b$export$5340cc94dd0ecbea = ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $42omo.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const handlerUnbind = (0, $fFa3V.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$a5e138d08f3fc65b$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $a5e138d08f3fc65b$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $42omo.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $a5e138d08f3fc65b$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $a5e138d08f3fc65b$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};
module.exports["RovoPostMessagePubsubListener"] = $a5e138d08f3fc65b$export$e5e1a9c59c299631;
module.exports["useRovoPostMessageToPubsub"] = $a5e138d08f3fc65b$export$5340cc94dd0ecbea;

});

parcelRegister("i25hX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c5134eb78e10703c$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed'
]);
const $c5134eb78e10703c$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let subIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
		 * Log that this Topic received a published event, regardless of whether it has subscribers or not.
		 * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
		 */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$c5134eb78e10703c$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $c5134eb78e10703c$var$pubSub = $c5134eb78e10703c$var$createPubSub();
const $c5134eb78e10703c$var$usePubSub = ()=>{
    return $c5134eb78e10703c$var$pubSub;
};
const $c5134eb78e10703c$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $c5134eb78e10703c$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $c5134eb78e10703c$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $c5134eb78e10703c$var$usePubSub();
    (0, $42omo.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $c5134eb78e10703c$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $c5134eb78e10703c$var$usePubSub();
    const publishFn = (0, $42omo.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $c5134eb78e10703c$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $c5134eb78e10703c$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $c5134eb78e10703c$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};
module.exports["useSubscribe"] = $c5134eb78e10703c$export$d3d523392640272;
module.exports["useSubscribeAll"] = $c5134eb78e10703c$export$2570c8aa24b6d327;
module.exports["usePublish"] = $c5134eb78e10703c$export$d55c81786220731c;
module.exports["Subscriber"] = $c5134eb78e10703c$export$60959659b2c22881;

});

parcelRegister("gKlAz", function(module, exports) {

var $eG1Z0 = parcelRequire("eG1Z0");


var $aoDcQ = parcelRequire("aoDcQ");

function $ac303ab343815a94$export$50d34f59d07755a2(mark, maybeNode) {
    const node = typeof maybeNode === 'string' ? (0, $aoDcQ.text)(maybeNode) : maybeNode;
    if ((0, $eG1Z0.isDuplicateMark)(node, mark.type)) {
        // eslint-disable-next-line no-console
        console.error((0, $eG1Z0.duplicateMarkError)(node, mark.type));
        return node;
    }
    node.marks = node.marks || [];
    node.marks.push(mark);
    return node;
}
module.exports["applyMark"] = $ac303ab343815a94$export$50d34f59d07755a2;

});

parcelRegister("eG1Z0", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9abe739d14fcbdba$export$5ec47a80d7cc0dfa(node, type) {
    if (node.marks && node.marks.some((mark)=>mark.type === type)) return true;
    return false;
}
function $9abe739d14fcbdba$export$db1000b9ac08ce57(node, type) {
    return `Mark with the same name '${type}' already exists on a node: ${JSON.stringify(node)}`;
}
module.exports["isDuplicateMark"] = $9abe739d14fcbdba$export$5ec47a80d7cc0dfa;
module.exports["duplicateMarkError"] = $9abe739d14fcbdba$export$db1000b9ac08ce57;

});

parcelRegister("aoDcQ", function(module, exports) {
const $cb8b1b1eb7a280a9$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });
module.exports["text"] = $cb8b1b1eb7a280a9$export$6f093cfa640b7166;

});

parcelRegister("iJQnc", function(module, exports) {

var $gKlAz = parcelRequire("gKlAz");

const $0c4bf63002e7b177$export$6565f9f03506010b = (maybeNode)=>(0, $gKlAz.applyMark)({
        type: 'code'
    }, maybeNode);
module.exports["code"] = $0c4bf63002e7b177$export$6565f9f03506010b;

});

parcelRegister("caRYB", function(module, exports) {
const $d9000e0d99d20134$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });
module.exports["doc"] = $d9000e0d99d20134$export$2a111da947c407d2;

});

parcelRegister("5x0y1", function(module, exports) {
const $548cbc934d83dd4c$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });
module.exports["inlineCard"] = $548cbc934d83dd4c$export$cbf8224b64e0d942;

});

parcelRegister("eyfm5", function(module, exports) {
const $6fd46c311db8d44c$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });
module.exports["listItem"] = $6fd46c311db8d44c$export$76c7e83ecc9cdf05;

});

parcelRegister("2FFuS", function(module, exports) {

var $enilC = parcelRequire("enilC");

const $a4fc62108e90d067$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $enilC.createTextNodes)(content)
    });
module.exports["paragraph"] = $a4fc62108e90d067$export$9c206ddddb32a9b;

});

parcelRegister("enilC", function(module, exports) {

var $aoDcQ = parcelRequire("aoDcQ");

function $b397a3d9dc60a40a$export$3a269a5941b62f04(nodes) {
    return nodes.map($b397a3d9dc60a40a$export$72b9432ea0656b50);
}
function $b397a3d9dc60a40a$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $aoDcQ.text)(str) : str;
}
module.exports["createTextNodes"] = $b397a3d9dc60a40a$export$3a269a5941b62f04;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("hcMBV", function(module, exports) {
var $87ac0097385af1df$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["RovoChatAction"] = "RovoChatAction";
    CardAction["ViewAction"] = "ViewAction";
    return CardAction;
}({});
module.exports["CardAction"] = $87ac0097385af1df$export$f40b7e0b762b928b;

});

parcelRegister("6mn0G", function(module, exports) {
function $ef5055edddfff711$export$e88cb5bfb57ce9c4(response) {
    try {
        return response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid') ?? null;
    } catch  {
        return null;
    }
}
module.exports["getTraceId"] = $ef5055edddfff711$export$e88cb5bfb57ce9c4;

});

parcelRegister("882hS", function(module, exports) {
$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("85Mv7")).pointerOutsideOfPreview);

var $85Mv7 = parcelRequire("85Mv7");


});

parcelRegister("85Mv7", function(module, exports) {

var $ic3Jg = parcelRequire("ic3Jg");


var $iFRCn = parcelRequire("iFRCn");


var $76xc7 = parcelRequire("76xc7");

function $30069a8958953d8b$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $iFRCn.isSafariOnIOS)() || (0, $ic3Jg.isAndroid)()) return (0, $76xc7.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}
module.exports["pointerOutsideOfPreview"] = $30069a8958953d8b$export$427e20518819fabc;

});

parcelRegister("iFRCn", function(module, exports) {

var $aYpzB = parcelRequire("aYpzB");


var $e880Z = parcelRequire("e880Z");

const $3720fb1a551ae595$export$52fc40c68fea4952 = (0, $aYpzB.once)(function isSafariOnIOS() {
    return (0, $e880Z.isSafari)() && 'ontouchend' in document;
});
module.exports["isSafariOnIOS"] = $3720fb1a551ae595$export$52fc40c68fea4952;

});

parcelRegister("76xc7", function(module, exports) {
const $54acc06d1c628398$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};
module.exports["centerUnderPointer"] = $54acc06d1c628398$export$81d8e72a15eef435;

});

parcelRegister("afUmf", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("3ts5j")).setCustomNativeDragPreview);

var $3ts5j = parcelRequire("3ts5j");


});

parcelRegister("3ts5j", function(module, exports) {

var $3CnSH = parcelRequire("3CnSH");


var $e880Z = parcelRequire("e880Z");


var $f7qXf = parcelRequire("f7qXf");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $90430ceac724b72d$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $90430ceac724b72d$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $90430ceac724b72d$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $f7qXf.maxZIndex),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $e880Z.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $3CnSH.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}
module.exports["setCustomNativeDragPreview"] = $90430ceac724b72d$export$52d889c66db0f96e;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $30lHU = parcelRequire("30lHU");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the context and pass them downstream
   * This prevents the missing messages error
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $30lHU.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    (0, $42omo.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
        return undefined;
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gc1M8 = parcelRequire("gc1M8");

var $jaEJa = parcelRequire("jaEJa");

var $cs1vW = parcelRequire("cs1vW");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $jaEJa.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $cs1vW.Context));
    if (!context) return (0, $gc1M8.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("2WHHL", function(module, exports) {
const $4de09c96514ff692$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $4de09c96514ff692$var$uniqueKey = Symbol('closestEdge');
function $4de09c96514ff692$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $4de09c96514ff692$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$4de09c96514ff692$var$uniqueKey]: addClosestEdge
    };
}
function $4de09c96514ff692$export$945a571f3b658bf(userData) {
    return userData[$4de09c96514ff692$var$uniqueKey] ?? null;
}
module.exports["attachClosestEdge"] = $4de09c96514ff692$export$f0cafff222395e89;
module.exports["extractClosestEdge"] = $4de09c96514ff692$export$945a571f3b658bf;

});

parcelRegister("iTTcV", function(module, exports) {
parcelRequire("d4P2q");
var $lFaps = parcelRequire("lFaps");


var $7XdU2 = parcelRequire("7XdU2");

function $57c56c1fb9914734$export$d0bc664d2812b3ba({ list: list, startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    return (0, $lFaps.reorder)({
        list: list,
        startIndex: startIndex,
        finishIndex: (0, $7XdU2.getReorderDestinationIndex)({
            closestEdgeOfTarget: closestEdgeOfTarget,
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            axis: axis
        })
    });
}
module.exports["reorderWithEdge"] = $57c56c1fb9914734$export$d0bc664d2812b3ba;

});

parcelRegister("d4P2q", function(module, exports) {
$parcel$export(module.exports, "reorder", () => (parcelRequire("lFaps")).reorder);

var $lFaps = parcelRequire("lFaps");


});

parcelRegister("lFaps", function(module, exports) {
/**
 * A function that will reorder an array (`list`).
 * `reorder` returns a new array with reordered items and does not
 *  modify the original array. The items in the array are also not modified.
 */ function $2e6a223576f565f2$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) // Making this function consistently return a new array reference.
    // This is consistent with .toSorted() which always returns a new array
    // even when it does not do anything
    return Array.from(list);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}
module.exports["reorder"] = $2e6a223576f565f2$export$fc77a6137e3f91c;

});

parcelRegister("7XdU2", function(module, exports) {
function $68bcb6b8502e57f3$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}
module.exports["getReorderDestinationIndex"] = $68bcb6b8502e57f3$export$846f792f51b92b6e;

});

parcelRegister("2n8po", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $31bj1 = parcelRequire("31bj1");


var $9JSVA = parcelRequire("9JSVA");

function $f0c37d2844a91b76$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $31bj1.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $9JSVA.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$f0c37d2844a91b76$export$2e2bcd8739ae039 = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["default"] = $f0c37d2844a91b76$export$2e2bcd8739ae039;

});

parcelRegister("31bj1", function(module, exports) {
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9JSVA = parcelRequire("9JSVA");

const $1707735fc36ab082$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $1707735fc36ab082$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $1707735fc36ab082$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $1707735fc36ab082$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $1707735fc36ab082$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $1707735fc36ab082$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $9JSVA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9JSVA.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $1707735fc36ab082$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $1707735fc36ab082$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $gMc0m.default)([
            $1707735fc36ab082$var$baseStyles.root,
            $1707735fc36ab082$var$orientationStyles[orientation],
            $1707735fc36ab082$var$edgeStyles[edge]
        ])
    });
} // For React.lazy
var $1707735fc36ab082$export$2e2bcd8739ae039 = $1707735fc36ab082$export$17d680238e50603e;
module.exports["Line"] = $1707735fc36ab082$export$17d680238e50603e;

});

parcelRegister("9JSVA", function(module, exports) {
const $795a0d6001dc944e$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $795a0d6001dc944e$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $795a0d6001dc944e$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $795a0d6001dc944e$export$45db03aa04b685e3;

});

parcelRegister("kiOFr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kSC7A = parcelRequire("kSC7A");


var $f8S0G = parcelRequire("f8S0G");


var $hBNGD = parcelRequire("hBNGD");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $bZKB2 = parcelRequire("bZKB2");


var $6fCTI = parcelRequire("6fCTI");

const $78f887db99bd3113$var$AVAILABLE_SITES_PATH = '/gateway/api/available-sites';
const $78f887db99bd3113$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/available-sites';
const $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_PATH = '/gateway/api/v2/accessible-products';
const $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/v2/accessible-products';
const $78f887db99bd3113$var$defaultProducts = [
    (0, $kSC7A.AvailableSitesProductType).WHITEBOARD,
    (0, $kSC7A.AvailableSitesProductType).BEACON,
    (0, $kSC7A.AvailableSitesProductType).COMPASS,
    (0, $kSC7A.AvailableSitesProductType).CONFLUENCE,
    (0, $kSC7A.AvailableSitesProductType).JIRA_BUSINESS,
    (0, $kSC7A.AvailableSitesProductType).JIRA_INCIDENT_MANAGER,
    (0, $kSC7A.AvailableSitesProductType).JIRA_PRODUCT_DISCOVERY,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SERVICE_DESK,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SOFTWARE,
    (0, $kSC7A.AvailableSitesProductType).MERCURY,
    (0, $kSC7A.AvailableSitesProductType).OPSGENIE,
    (0, $kSC7A.AvailableSitesProductType).STATUS_PAGE,
    (0, $kSC7A.AvailableSitesProductType).ATLAS,
    (0, $kSC7A.AvailableSitesProductType).LOOM
];
const $78f887db99bd3113$export$3738ff0cbe469211 = ({ gatewayBaseUrl: gatewayBaseUrl } = {})=>{
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const { sites: sites } = await $78f887db99bd3113$var$getAvailableSites({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                setState({
                    data: sites,
                    loading: false,
                    error: undefined
                });
            } catch (err) {
                createAnalyticsEvent((0, $f8S0G.default)('operational.getAvailableSitesResolve.failed', (0, $6fCTI.getOperationFailedAttributes)(err))).fire((0, $hBNGD.ANALYTICS_CHANNEL));
                const error = err instanceof Error ? err : new Error('unknown error');
                setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl
    ]);
    return state;
};
const $78f887db99bd3113$export$bd4055e8b60f8535 = (data)=>{
    const sites = [];
    data.products.forEach((product)=>{
        product.workspaces.forEach((workspace)=>{
            const currentSite = sites.find((site)=>site.cloudId === workspace.cloudId);
            if (currentSite) {
                currentSite.products.push(product.productId);
                return currentSite;
            }
            sites.push({
                avatarUrl: workspace.workspaceAvatarUrl,
                cloudId: workspace.cloudId,
                displayName: workspace.workspaceDisplayName,
                isVertigo: workspace.vortexMode === 'ENABLED',
                products: [
                    product.productId
                ],
                url: workspace.cloudUrl
            });
        });
    });
    return sites;
};
const $78f887db99bd3113$export$3f59b707a86875c4 = ({ gatewayBaseUrl: gatewayBaseUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isMounted = (0, $bZKB2.useIsMounted)();
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const response = await $78f887db99bd3113$var$getAccessibleProducts({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                if (isMounted()) setState({
                    data: $78f887db99bd3113$export$bd4055e8b60f8535(response.data),
                    loading: false,
                    error: undefined
                });
            } catch (error) {
                if (isMounted()) setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        isMounted
    ]);
    return state;
};
async function $78f887db99bd3113$var$getAvailableSites({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const availableSitesPath = (0, $dh538.fg)('linking_platform_site_picker_api_unit_compliant') ? $78f887db99bd3113$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH : $78f887db99bd3113$var$AVAILABLE_SITES_PATH;
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: products
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}${availableSitesPath}` : availableSitesPath, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
async function $78f887db99bd3113$var$getAccessibleProducts({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const accessibleProductsPath = (0, $dh538.fg)('linking_platform_site_picker_api_unit_compliant') ? $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_UNIT_COMPLIANT_PATH : $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_PATH;
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            productIds: products,
            permissionIds: []
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}${accessibleProductsPath}` : accessibleProductsPath, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
module.exports["useAvailableSites"] = $78f887db99bd3113$export$3738ff0cbe469211;
module.exports["mapAccessibleProductsToAvailableSites"] = $78f887db99bd3113$export$bd4055e8b60f8535;
module.exports["useAvailableSitesV2"] = $78f887db99bd3113$export$3f59b707a86875c4;

});

parcelRegister("kSC7A", function(module, exports) {
var $2f440bf1e6112d68$export$16bdf84263b17cf0 = /*#__PURE__*/ function(AvailableSitesProductType) {
    AvailableSitesProductType["WHITEBOARD"] = "atlassian-whiteboard";
    AvailableSitesProductType["BEACON"] = "beacon";
    AvailableSitesProductType["COMPASS"] = "compass";
    AvailableSitesProductType["CONFLUENCE"] = "confluence.ondemand";
    AvailableSitesProductType["JIRA_BUSINESS"] = "jira-core.ondemand";
    AvailableSitesProductType["JIRA_INCIDENT_MANAGER"] = "jira-incident-manager.ondemand";
    AvailableSitesProductType["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    AvailableSitesProductType["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    AvailableSitesProductType["JIRA_SOFTWARE"] = "jira-software.ondemand";
    AvailableSitesProductType["MERCURY"] = "mercury";
    AvailableSitesProductType["OPSGENIE"] = "opsgenie";
    AvailableSitesProductType["STATUS_PAGE"] = "statuspage";
    AvailableSitesProductType["ATLAS"] = "townsquare";
    AvailableSitesProductType["LOOM"] = "loom";
    return AvailableSitesProductType;
}({});
module.exports["AvailableSitesProductType"] = $2f440bf1e6112d68$export$16bdf84263b17cf0;

});

parcelRegister("f8S0G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::6aeaf735bb1855a8d29ca67bd7a680b4>>
 * @codegenCommand yarn workspace @atlaskit/linking-common run codegen-analytics
 */ function $4a22b51dcbeecd57$var$createEventPayload(eventKey, attributes) {
    const event = eventKey.split('.');
    return {
        eventType: event[0],
        actionSubject: event[1],
        action: event[2],
        actionSubjectId: event[3],
        attributes: attributes
    };
}
var $4a22b51dcbeecd57$export$2e2bcd8739ae039 = $4a22b51dcbeecd57$var$createEventPayload;
module.exports["default"] = $4a22b51dcbeecd57$export$2e2bcd8739ae039;

});

parcelRegister("hBNGD", function(module, exports) {
const $eb5d052cb0327301$export$85183a312807388d = 'media';
const $eb5d052cb0327301$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $eb5d052cb0327301$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $eb5d052cb0327301$export$60efea3f80310017;

});

parcelRegister("bZKB2", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d79b64f48ff0234f$export$80c2a3957bcb42ea() {
    const isMounted = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $42omo.useCallback)(()=>isMounted.current, []);
}
module.exports["useIsMounted"] = $d79b64f48ff0234f$export$80c2a3957bcb42ea;

});

parcelRegister("6fCTI", function(module, exports) {

var $6mn0G = parcelRequire("6mn0G");

const $9cbe6bde573cd7a4$var$getUrlPath = (url)=>{
    try {
        return new URL(url).pathname;
    } catch  {
        return 'Failed to parse pathname from url';
    }
};
const $9cbe6bde573cd7a4$export$294520aca64d4e59 = (error)=>{
    if (error instanceof Response) return {
        traceId: (0, $6mn0G.getTraceId)(error),
        status: error.status,
        path: $9cbe6bde573cd7a4$var$getUrlPath(error.url)
    };
    return {
        traceId: null,
        status: null,
        path: null
    };
};
const $9cbe6bde573cd7a4$export$e19f9f08a6d79fd2 = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $9cbe6bde573cd7a4$export$b2d107ab31565d0b = (err)=>{
    if (err instanceof Response) return {
        error: 'NetworkError',
        errorType: 'NetworkError',
        ...$9cbe6bde573cd7a4$export$294520aca64d4e59(err)
    };
    const error = err instanceof Error ? err : new Error('unknown error');
    return {
        error: error.name,
        errorType: error.name,
        traceId: null,
        status: null,
        path: null
    };
};
module.exports["getOperationFailedAttributes"] = $9cbe6bde573cd7a4$export$b2d107ab31565d0b;

});

parcelRegister("i2CQL", function(module, exports) {

var $g99e4 = parcelRequire("g99e4");


var $jRNsq = parcelRequire("jRNsq");

const $4af3bbf76333cbc2$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $g99e4.useStore)(store, selector, equals);
function $4af3bbf76333cbc2$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $4af3bbf76333cbc2$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $4af3bbf76333cbc2$export$8a9cc8c330400af8;

});

parcelRegister("g99e4", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $bc14a4aa688fca7b$export$6ccbb43953eebf8);

var $9mu1x = parcelRequire("9mu1x");


var $42omo = parcelRequire("42omo");


var $hpRUx = parcelRequire("hpRUx");

var $bc14a4aa688fca7b$import_meta = Object.assign(Object.create(null), {
    url: "file:///../platform/node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $bc14a4aa688fca7b$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
const { useSyncExternalStoreWithSelector: $bc14a4aa688fca7b$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($hpRUx)));
let $bc14a4aa688fca7b$var$didWarnAboutEqualityFn = false;
const $bc14a4aa688fca7b$var$identity = (arg)=>arg;
function $bc14a4aa688fca7b$export$6ccbb43953eebf8(api, selector = $bc14a4aa688fca7b$var$identity, equalityFn) {
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$bc14a4aa688fca7b$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $bc14a4aa688fca7b$var$didWarnAboutEqualityFn = true;
    }
    const slice = $bc14a4aa688fca7b$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $bc14a4aa688fca7b$var$useDebugValue(slice);
    return slice;
}
const $bc14a4aa688fca7b$var$createImpl = (createState)=>{
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $9mu1x.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$bc14a4aa688fca7b$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $bc14a4aa688fca7b$export$185802fd694ee1f5 = (createState)=>createState ? $bc14a4aa688fca7b$var$createImpl(createState) : $bc14a4aa688fca7b$var$createImpl;
var $bc14a4aa688fca7b$export$2e2bcd8739ae039 = (createState)=>{
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $bc14a4aa688fca7b$export$185802fd694ee1f5(createState);
};

});

parcelRegister("lOHzS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::550a63d3b233a1e606c45af1b8952b33>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe2012194714c5ae$var$_react = $fe2012194714c5ae$var$_interopRequireDefault((parcelRequire("42omo")));

var $fe2012194714c5ae$var$_baseNew = $fe2012194714c5ae$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fe2012194714c5ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe2012194714c5ae$var$VideoPlayIcon = (props)=>/*#__PURE__*/ $fe2012194714c5ae$var$_react.default.createElement($fe2012194714c5ae$var$_baseNew.default, Object.assign({
        name: "VideoPlayIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888zm2.24-.438a.5.5 0 0 0-.74.438v9.776a.5.5 0 0 0 .74.438l8.903-4.888a.5.5 0 0 0 0-.876z" clip-rule="evenodd"/>`
    }, props));
$fe2012194714c5ae$var$VideoPlayIcon.displayName = 'VideoPlayIcon';
var $fe2012194714c5ae$var$_default = module.exports.default = $fe2012194714c5ae$var$VideoPlayIcon;

});

parcelRegister("d2kvf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1HnpQ = parcelRequire("1HnpQ");


var $i3GYc = parcelRequire("i3GYc");

// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $7cea5ab07179eb6f$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $i3GYc.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1HnpQ.default), {
        as: "div",
        isInset: true,
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
            children: children
        })
    });
};
var $7cea5ab07179eb6f$export$2e2bcd8739ae039 = $7cea5ab07179eb6f$var$TabPanel;
module.exports["default"] = $7cea5ab07179eb6f$export$2e2bcd8739ae039;

});

parcelRegister("e7URT", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a48dd4fd18e75a65$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a48dd4fd18e75a65$var$isUndefined;

});

parcelRegister("3C50A", function(module, exports) {

var $apAFY = parcelRequire("apAFY");


var $bHD89 = parcelRequire("bHD89");


var $1J0ov = parcelRequire("1J0ov");

const $24a3efb1cf8e29fc$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $bHD89.ANALYTICS_BRIDGE_CHANNEL));
};
const $24a3efb1cf8e29fc$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $24a3efb1cf8e29fc$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};
module.exports["fireAnalytics"] = $24a3efb1cf8e29fc$export$34ac71ce24cddec2;
module.exports["fireUIAnalytics"] = $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94;
module.exports["fireTrackAnalytics"] = $24a3efb1cf8e29fc$export$13990ad4625571ed;
module.exports["fireOperationalAnalytics"] = $24a3efb1cf8e29fc$export$79f423cc3fd39762;

});

parcelRegister("bHD89", function(module, exports) {
const $f220a889fcad0dca$export$f636b5b56f1d624a = 'Screen';
const $f220a889fcad0dca$export$9d2de6eebf7462b5 = 'Drawer';
const $f220a889fcad0dca$export$1171103ea9083ffa = 'Modal';
const $f220a889fcad0dca$export$cae2783c9279926 = 'InlineDialog';
const $f220a889fcad0dca$export$d1123261ca8831d2 = 'Dropdown';
const $f220a889fcad0dca$export$a1562d08625f5d7e = 'UI';
const $f220a889fcad0dca$export$947dac6c72b26f81 = 'TRACK';
const $f220a889fcad0dca$export$f1d537d508d2945a = 'SCREEN';
const $f220a889fcad0dca$export$12346a674644c156 = 'OPERATIONAL';
const $f220a889fcad0dca$export$2ceccf177fae277c = 'analyticsBridge';
module.exports["SCREEN"] = $f220a889fcad0dca$export$f636b5b56f1d624a;
module.exports["MODAL"] = $f220a889fcad0dca$export$1171103ea9083ffa;
module.exports["UI_EVENT_TYPE"] = $f220a889fcad0dca$export$a1562d08625f5d7e;
module.exports["TRACK_EVENT_TYPE"] = $f220a889fcad0dca$export$947dac6c72b26f81;
module.exports["SCREEN_EVENT_TYPE"] = $f220a889fcad0dca$export$f1d537d508d2945a;
module.exports["OPERATIONAL_EVENT_TYPE"] = $f220a889fcad0dca$export$12346a674644c156;
module.exports["ANALYTICS_BRIDGE_CHANNEL"] = $f220a889fcad0dca$export$2ceccf177fae277c;

});

parcelRegister("1J0ov", function(module, exports) {
const $9c601e99598456fc$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $9c601e99598456fc$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $9c601e99598456fc$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $9c601e99598456fc$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $9c601e99598456fc$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $9c601e99598456fc$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};
module.exports["getImperativeAnalyticsDataFromArguments"] = $9c601e99598456fc$export$e6baab532ef8c6bf;

});

parcelRegister("da6ky", function(module, exports) {

var $ghltV = parcelRequire("ghltV");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $99511ea06e3a3663$var$uniq(array) {
    return array && array.length ? $ghltV(array) : [];
}
module.exports = $99511ea06e3a3663$var$uniq;

});

parcelRegister("hwDTW", function(module, exports) {

var $eHPLt = parcelRequire("eHPLt");


var $1WABR = parcelRequire("1WABR");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");


var $bRRFB = parcelRequire("bRRFB");


var $cSA01 = parcelRequire("cSA01");


var $erbrP = parcelRequire("erbrP");


var $gQUlr = parcelRequire("gQUlr");

/** `Object#toString` result references. */ var $cc24605e9ae7f4f1$var$mapTag = '[object Map]', $cc24605e9ae7f4f1$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $cc24605e9ae7f4f1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cc24605e9ae7f4f1$var$hasOwnProperty = $cc24605e9ae7f4f1$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $cc24605e9ae7f4f1$var$isEmpty(value) {
    if (value == null) return true;
    if ($bRRFB(value) && ($fZxmY(value) || typeof value == 'string' || typeof value.splice == 'function' || $cSA01(value) || $gQUlr(value) || $dI6Ko(value))) return !value.length;
    var tag = $1WABR(value);
    if (tag == $cc24605e9ae7f4f1$var$mapTag || tag == $cc24605e9ae7f4f1$var$setTag) return !value.size;
    if ($erbrP(value)) return !$eHPLt(value).length;
    for(var key in value){
        if ($cc24605e9ae7f4f1$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $cc24605e9ae7f4f1$var$isEmpty;

});

parcelRegister("hzZxz", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $e7URT = parcelRequire("e7URT");


var $1j3sF = parcelRequire("1j3sF");


var $bHD89 = parcelRequire("bHD89");


var $01od0 = parcelRequire("01od0");

const $50a1a1624abaf5e4$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $01od0.getAnalyticsType)(castedEvent);
    const attributes = (0, $01od0.getAttributes)(castedEvent);
    const source = (0, $01od0.getSource)(castedEvent);
    const actionSubject = (0, $01od0.getActionSubject)(castedEvent);
    if (analyticsType === (0, $bHD89.SCREEN_EVENT_TYPE)) return {
        type: (0, $bHD89.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $bHD89.UI_EVENT_TYPE:
        case 0, $bHD89.TRACK_EVENT_TYPE:
        case 0, $bHD89.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $01od0.getAction)(castedEvent);
                const actionSubjectId = (0, $01od0.getActionSubjectId)(castedEvent);
                const containerId = (0, $01od0.getContainerId)(castedEvent);
                const containerType = (0, $01od0.getContainerType)(castedEvent);
                const objectId = (0, $01od0.getObjectId)(castedEvent);
                const objectType = (0, $01od0.getObjectType)(castedEvent);
                const tags = (0, $01od0.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};
module.exports["extractAWCDataFromEvent"] = $50a1a1624abaf5e4$export$1c850cf68c053906;

});

parcelRegister("01od0", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $e7URT = parcelRequire("e7URT");


var $apAFY = parcelRequire("apAFY");


var $lgmus = parcelRequire("lgmus");


var $1j3sF = parcelRequire("1j3sF");


var $da6ky = parcelRequire("da6ky");

const $4b9739432bab74fb$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $4b9739432bab74fb$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $4b9739432bab74fb$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $4b9739432bab74fb$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $4b9739432bab74fb$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))));
};
const $4b9739432bab74fb$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'source').filter(Boolean));
const $4b9739432bab74fb$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $4b9739432bab74fb$export$6ca3170acb89054 = (event)=>event.payload.action;
const $4b9739432bab74fb$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $4b9739432bab74fb$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'containerId').filter(Boolean));
const $4b9739432bab74fb$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'containerType').filter(Boolean));
const $4b9739432bab74fb$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'objectId').filter(Boolean));
const $4b9739432bab74fb$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'objectType').filter(Boolean));
const $4b9739432bab74fb$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))((0, (/*@__PURE__*/$parcel$interopDefault($5qOzM)))($4b9739432bab74fb$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
module.exports["getAnalyticsType"] = $4b9739432bab74fb$export$a3569ac53b82a914;
module.exports["getAttributes"] = $4b9739432bab74fb$export$fe94072fee8a6976;
module.exports["getSource"] = $4b9739432bab74fb$export$dd2b6e807fb37ba3;
module.exports["getActionSubject"] = $4b9739432bab74fb$export$6f40cdf6d42c018d;
module.exports["getAction"] = $4b9739432bab74fb$export$6ca3170acb89054;
module.exports["getActionSubjectId"] = $4b9739432bab74fb$export$b6f8db3ad0711b02;
module.exports["getContainerId"] = $4b9739432bab74fb$export$7c8178cc9001d237;
module.exports["getContainerType"] = $4b9739432bab74fb$export$acc6f3e19803b3dc;
module.exports["getObjectId"] = $4b9739432bab74fb$export$fa986b91291934c7;
module.exports["getObjectType"] = $4b9739432bab74fb$export$11cc42aebef2ef3a;
module.exports["getTags"] = $4b9739432bab74fb$export$af63d7414243dad3;

});

parcelRegister("eoZW1", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $639791195d5194df$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $639791195d5194df$export$2e2bcd8739ae039 = $639791195d5194df$export$852ff24d0930c62f;
module.exports["default"] = $639791195d5194df$export$2e2bcd8739ae039;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("69PnT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2228fa01b7e8b5ee470ffc60df47923d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47bb7135644f74cd$var$_react = $47bb7135644f74cd$var$_interopRequireDefault((parcelRequire("42omo")));

var $47bb7135644f74cd$var$_baseNew = $47bb7135644f74cd$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $47bb7135644f74cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $47bb7135644f74cd$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $47bb7135644f74cd$var$_react.default.createElement($47bb7135644f74cd$var$_baseNew.default, Object.assign({
        name: "ArrowUpRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$47bb7135644f74cd$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $47bb7135644f74cd$var$_default = module.exports.default = $47bb7135644f74cd$var$ArrowUpRightIcon;

});

parcelRegister("bre0g", function(module, exports) {

var $2cmfr = parcelRequire("2cmfr");

class $1d9210071da756d7$export$2e2bcd8739ae039 {
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            const nodes = manifest?.modules?.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                preloadCalls.push(node?.preloadRender?.());
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    getPreloadedExtension(type, key) {
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = manifests.find((manifest)=>manifest.type === type && manifest.key === key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $2cmfr.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsPromise = void 0;
        this.manifestsCache = [];
        this.autoConvertHandlers = void 0;
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
}
module.exports["default"] = $1d9210071da756d7$export$2e2bcd8739ae039;

});

parcelRegister("7dyLS", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $lEY55 = parcelRequire("lEY55");


var $iUYhn = parcelRequire("iUYhn");


var $eFiFf = parcelRequire("eFiFf");


var $3YFt4 = parcelRequire("3YFt4");

var $ff4c1fab1412a389$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["townsquare"] = "TOWNSQUARE";
    Products["trello"] = "TRELLO";
    Products["bitbucket"] = "BITBUCKET";
    Products["other"] = "OTHER";
    return Products;
}({});
const $ff4c1fab1412a389$export$775b6bb06e53a214 = {
    ...(0, $lEY55.Scope),
    ...(0, $iUYhn.Scope),
    ...(0, $3YFt4.TownsquareScope),
    ...(0, $eFiFf.Scope)
};
module.exports["Scope"] = $ff4c1fab1412a389$export$775b6bb06e53a214;

});

parcelRegister("lEY55", function(module, exports) {
/**
 * Instead of enum types for ResultType, AnalyticsType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $31e4730094d25be0$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    Scope["ConfluencePageBlogWhiteboard"] = "confluence.page,blogpost,whiteboard";
    Scope["ConfluenceContentType"] = "confluence.page,blogpost,whiteboard,database,embed";
    return Scope;
}({});
const $31e4730094d25be0$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $31e4730094d25be0$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $31e4730094d25be0$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $31e4730094d25be0$export$7694915d49dbf79 = 'confluence_experiments.page,blogpost,whiteboard';
const $31e4730094d25be0$export$2d908678acc2f256 = 'confluence_experiments.page,blogpost,whiteboard,database,embed';
const $31e4730094d25be0$export$80a5be864676016b = 'confluence.space';
const $31e4730094d25be0$export$70542451ad6057d2 = 'urs.user-confluence';
const $31e4730094d25be0$export$6ec00f56b27cdc1d = 'generic-container-result';
const $31e4730094d25be0$export$ca1a50bc869949e = 'person-result';
const $31e4730094d25be0$export$a99961038e9d5471 = 'confluence-object-result';
const $31e4730094d25be0$export$18c69de2b4aa679c = 'recent-confluence';
const $31e4730094d25be0$export$dc31f0db54ab1a30 = 'result-confluence';
const $31e4730094d25be0$export$cb8b6c470492bee8 = 'recent-person';
const $31e4730094d25be0$export$ebb42dafe7a39a20 = 'result-person';
const $31e4730094d25be0$export$602b44a55c824e30 = 'advanced-search-confluence';
const $31e4730094d25be0$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $31e4730094d25be0$export$bbd1709e62826142 = 'confluence-page';
const $31e4730094d25be0$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $31e4730094d25be0$export$b441f0c13fd510b9 = 'confluence-attachment';
const $31e4730094d25be0$export$8ee8726ca4e2f8bd = 'confluence-space';
const $31e4730094d25be0$export$d0e824889e01c751 = 'person';
const $31e4730094d25be0$export$b0c74445b9c9b57 = 'confluence-app';
module.exports["Scope"] = $31e4730094d25be0$export$775b6bb06e53a214;

});

parcelRegister("iUYhn", function(module, exports) {
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $4cce666965dd4176$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $4cce666965dd4176$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $4cce666965dd4176$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $4cce666965dd4176$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $4cce666965dd4176$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});
module.exports["Scope"] = $4cce666965dd4176$export$775b6bb06e53a214;

});

parcelRegister("eFiFf", function(module, exports) {
var $e9e0239fba21ef53$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Loom"] = "loom.loom";
    return Scope;
}({});
module.exports["Scope"] = $e9e0239fba21ef53$export$775b6bb06e53a214;

});

parcelRegister("3YFt4", function(module, exports) {
var $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareQuestion"] = "townsquare.question";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});
 // End of copied code.
module.exports["TownsquareScope"] = $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa;

});

parcelRegister("3paC4", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $jppmC = parcelRequire("jppmC");

const $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY = 3;
const $6b372c322d10f06f$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY);
};
class $6b372c322d10f06f$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $6b372c322d10f06f$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $jppmC.timed)(this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $6b372c322d10f06f$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $6b372c322d10f06f$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};
module.exports["createClient"] = $6b372c322d10f06f$export$5d730b7aed1a3eb0;

});

parcelRegister("jppmC", function(module, exports) {
const $e3bb250125deb745$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $e3bb250125deb745$export$d35186a762cd39c8;

});

parcelRegister("8hhCV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $02745cd2b6b0665c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c46a68f431db1746de65e15ef846dc14>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $kXb3C = parcelRequire("kXb3C");

function $02745cd2b6b0665c$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("57Wda", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::599e4be29a2a39bcbf5cf9b372d0e03e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6B0jU = parcelRequire("6B0jU");


var $kXb3C = parcelRequire("kXb3C");

function $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039({ label: label = 'Database', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("eQfRp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $26650821103220c8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a634b13ea98c89a9c27945d37a8a7571>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ZDq1z = parcelRequire("ZDq1z");


var $kXb3C = parcelRequire("kXb3C");

function $26650821103220c8$export$2e2bcd8739ae039({ label: label = 'Whiteboard', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        color: "var(--ds-icon-accent-teal, #2898BD)"
    });
}

});

parcelRegister("kZ5GD", function(module, exports) {
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />
// for typing `process`

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $dh538 = parcelRequire("dh538");

const $56d63ff022409480$var$packageName = "platform-pkg";
const $56d63ff022409480$var$packageVersion = "0.0.0-use.local";
const $56d63ff022409480$var$noop = (0, $ee7An.default);
const $56d63ff022409480$var$labelPaddingStyles = null;
const $56d63ff022409480$var$labelStyles = null; // These styles should be removed when the platform-radio-atomic-styles feature gate is cleaned up.
const $56d63ff022409480$var$labelLegacyStyles = null;
const $56d63ff022409480$var$labelDisabledStyles = null;
const $56d63ff022409480$var$radioBaseStyles = null;
const $56d63ff022409480$var$radioInteractiveStyles = null;
const $56d63ff022409480$var$radioDisabledStyles = null;
const $56d63ff022409480$var$radioDisabledCheckedStyles = null; // These styles are applied when the platform-radio-atomic-styles feature gate is disabled.
// When the feature gate is cleaned up, this style block can be removed.
const $56d63ff022409480$var$radioLegacyStyles = null;
const $56d63ff022409480$var$radioInvalidStyles = null;
const $56d63ff022409480$var$InnerRadio = /*#__PURE__*/ (0, $42omo.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $56d63ff022409480$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $56d63ff022409480$var$packageName,
        packageVersion: $56d63ff022409480$var$packageVersion
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazi7uo",
            !(0, $dh538.fg)('platform-radio-atomic-styles') && "_mqf81gmx _g7st13gf",
            isDisabled && (0, $dh538.fg)('platform-radio-atomic-styles') && "_syaz1gmx _80om13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                "aria-labelledby": labelId || ariaLabelledBy,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $gMc0m.default)([
                    "_18s8ze3t _19it3vzd _2rko1qll _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6q1j9a _1151rsbi _1s6w5w2r _tqbwidpf _t9ec1soj _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1qll _qc5orqeg _z0ai120g _1qdg120g _18postnw _aetrb3bt _1peq1xmd",
                    !(0, $dh538.fg)('platform-radio-atomic-styles') && "_iosijmqp _11jyjmqp _f3ett94y _y2mvdfik _1bg41l7b _6tjkdfik _awqn1l7b _1rvql4ek _1p9jrsbi _x2tz1q28 _1iwz1q28 _sj8yr01l _jcko12kk _1dvdrsbi _60ak5w2r",
                    !(0, $dh538.fg)('platform-radio-atomic-styles') && "_19ybs4qr _1d7ps4qr _j5dh13gf _scgf13gf _4fps13gf _5ry313gf _qep213gf _180n13gf _1gcs13gf _1x1a13gf _6hp813gf _4ryaby5v _o1bdby5v _2kbkby5v _6cyrby5v _n8t0by5v _1o5rby5v _nxi6by5v _neoeby5v _1el2by5v _lekrbk0g _11v7bk0g _1if1bk0g _bl0ebk0g _92nabk0g _awurbk0g _1f8cbk0g _s2ftbk0g _17a1bk0g _x48a2sac _1ib22sac _wml02sac _tusm2sac _1c6f2sac _qftt2sac _1yk92sac _gdmb2sac _pmm42sac",
                    !isDisabled && (0, $dh538.fg)('platform-radio-atomic-styles') && "_iosijmqp _11jyjmqp _f3ett94y _y2mvdfik _1bg41l7b _6tjkdfik _awqn1l7b _1rvql4ek _1p9jrsbi _x2tz1q28 _1iwz1q28 _sj8yr01l _jcko12kk _1dvdrsbi _60ak5w2r",
                    isDisabled && (0, $dh538.fg)('platform-radio-atomic-styles') && "_80om13gf _1q6qby5v _1151bk0g _1s6w2sac",
                    isDisabled && isChecked && (0, $dh538.fg)('platform-radio-atomic-styles') && "_tqbwt94y",
                    isInvalid && !isDisabled && (0, $dh538.fg)('platform-radio-atomic-styles') && "_1151s4qr _11jys4qr"
                ])
            }),
            label ? /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $56d63ff022409480$var$Radio = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($56d63ff022409480$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $56d63ff022409480$export$2e2bcd8739ae039 = $56d63ff022409480$var$Radio;
module.exports["default"] = $56d63ff022409480$export$2e2bcd8739ae039;

});

parcelRegister("10CSJ", function(module, exports) {

var $42omo = parcelRequire("42omo");



class $330e3eb3197f64f9$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser) Promise.all([
            (parcelRequire("bmRAn")),
            (parcelRequire("eqCNj"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
        };
    }
}
$330e3eb3197f64f9$export$3ce634ac4a869e2c.displayName = 'AsyncBrowser';
$330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = void 0;
module.exports["BrowserLoader"] = $330e3eb3197f64f9$export$3ce634ac4a869e2c;

});

parcelRegister("bmRAn", function(module, exports) {

let $846b50c9d603e7cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $846b50c9d603e7cb$var$load("gOOwE"),
    $846b50c9d603e7cb$var$load("8Vzcw"),
    $846b50c9d603e7cb$var$load("co52j"),
    $846b50c9d603e7cb$var$load("8j9XC"),
    $846b50c9d603e7cb$var$load("6aruy")
]).then(()=>parcelRequire('9VKkC'));

});

parcelRegister("eqCNj", function(module, exports) {

let $a81196217acfe6a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a81196217acfe6a7$var$load("8j9XC"),
    $a81196217acfe6a7$var$load("gOOwE"),
    $a81196217acfe6a7$var$load("f35QR"),
    $a81196217acfe6a7$var$load("eVYW1"),
    $a81196217acfe6a7$var$load("ls0Um"),
    $a81196217acfe6a7$var$load("020xd"),
    $a81196217acfe6a7$var$load("eTBsW"),
    $a81196217acfe6a7$var$load("bYxCZ"),
    $a81196217acfe6a7$var$load("6HBYC"),
    $a81196217acfe6a7$var$load("eDqo1"),
    $a81196217acfe6a7$var$load("lxiFd"),
    $a81196217acfe6a7$var$load("1oiJ6"),
    $a81196217acfe6a7$var$load("huUvS"),
    $a81196217acfe6a7$var$load("dT77m"),
    $a81196217acfe6a7$var$load("6vhrJ"),
    $a81196217acfe6a7$var$load("fxC6e"),
    $a81196217acfe6a7$var$load("hqblC")
]).then(()=>parcelRequire('4rZL5'));

});

parcelRegister("IBZYB", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $8dfa4f5c71224290$export$3d5265f8773197d = ({ maxNumberOfItemsPerRow: maxNumberOfItemsPerRow, numberOfItems: numberOfItems, isRow: isRow })=>{
    // Indices represents the leftmost item and rightmost item currently in view.
    const [window, setWindow] = (0, $42omo.useState)([
        0,
        0
    ]);
    // Used for scrolling to a particular item. Set to -1 by default as we haven't scrolled yet.
    const [scrollToIndex, setScrollToIndex] = (0, $42omo.useState)(-1);
    // Used to keep track of which item is currently being edited in the config panel to adjust window accordingly.
    const [requestedScrollIndex, setRequestedScrollIndex] = (0, $42omo.useState)(-1);
    (0, $42omo.useEffect)(()=>{
        {
            // Viewable window indexes are inclusive of left and right index, so we need to decrement by one unless maxNumberOfItemsPerRow is 0.
            // Examples:
            // Cards: 1 2 3 4 5, Card indexes: 0 1 2 3 4
            // maxNumberOfItemsPerRow is 0, current left index is at card 1 (ie. index 0) --> right index should be at card 1 (index 0), 1 card in view. Calculation: 0 + 0 - 0 = 0
            // maxNumberOfItemsPerRow is 2, current left index is at card 1 (ie. index 0) --> right index should be at card 2 (index 1), 2 cards in view. Calculation: 0 + 2 - 1 = 1
            // maxNumberOfItemsPerRow is 3, current left index is at card 2 (ie. index 1) --> right index should be at card 4 (index 3), 3 cards in view. Calculation: 1 + 3 - 1 = 3
            const extraDecrement = maxNumberOfItemsPerRow === 0 ? 0 : 1;
            const newRightIndex = window[0] + maxNumberOfItemsPerRow - extraDecrement;
            setWindow([
                window[0],
                newRightIndex
            ]);
        }
        if (requestedScrollIndex >= 0) {
            // Trigger scroll unconditionally, this works for grid view as well (which doesn't use the window logic)
            setScrollToIndex(requestedScrollIndex);
            // Only update the window in row orientation, as we don't use a window for grid view.
            if (isRow) {
                if (requestedScrollIndex !== window[0] && requestedScrollIndex !== window[1]) {
                    // This means we've scrolled somewhere left beyond the existing visible window, so we update the window to the left.
                    if (requestedScrollIndex < window[0]) setWindow([
                        requestedScrollIndex,
                        requestedScrollIndex + maxNumberOfItemsPerRow - 1
                    ]);
                    else if (requestedScrollIndex > window[1]) setWindow([
                        requestedScrollIndex - maxNumberOfItemsPerRow + 1,
                        requestedScrollIndex
                    ]);
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        maxNumberOfItemsPerRow,
        requestedScrollIndex,
        isRow
    ]);
    const scrollToPrevious = (0, $42omo.useCallback)(()=>{
        const newLeftIndex = window[0] - 1;
        const newRightIndex = window[1] - 1;
        setWindow([
            newLeftIndex,
            newRightIndex
        ]);
        setScrollToIndex(newLeftIndex);
    }, [
        window
    ]);
    const scrollToNext = ()=>{
        const newLeftIndex = window[0] + 1;
        const newRightIndex = window[1] + 1;
        setWindow([
            newLeftIndex,
            newRightIndex
        ]);
        setScrollToIndex(newRightIndex);
    };
    (0, $42omo.useEffect)(()=>{
        // If user deletes an item near the end of the list, our window of
        // items being shown may need recalculating (if right index is too high)
        if (window[1] > numberOfItems - 1 && window[0] > 0) scrollToPrevious();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        numberOfItems,
        scrollToPrevious
    ]);
    const noScrollNeeded = numberOfItems <= maxNumberOfItemsPerRow;
    const isAtBeginning = noScrollNeeded || window[0] === 0;
    const isAtEnd = noScrollNeeded || window[1] === numberOfItems - 1;
    const resetScrollIndex = ()=>{
        setScrollToIndex(-1);
    };
    return {
        isAtBeginning: isAtBeginning,
        isAtEnd: isAtEnd,
        scrollToPrevious: scrollToPrevious,
        scrollToNext: scrollToNext,
        scrollToIndex: scrollToIndex,
        requestScrollIndex: setRequestedScrollIndex,
        resetScrollIndex: resetScrollIndex
    };
};
module.exports["useOrientationScrolling"] = $8dfa4f5c71224290$export$3d5265f8773197d;

});

parcelRegister("lPcXt", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $fea56e716edbc72a$export$1a197eb476b94cd9 = 16;
const $fea56e716edbc72a$export$622d6c2ee56322dc = 16;
const $fea56e716edbc72a$var$MAX_NUMBER_OF_ITEMS_PER_ROW = 6;
const $fea56e716edbc72a$export$a6443181a5681c94 = ({ numberOfCards: numberOfCards, cardDimensions: cardDimensions, getItemDimensions: getItemDimensions })=>{
    const [currentCardsGridWidth, setCurrentCardsGridWidth] = (0, $42omo.useState)(0);
    const [currentCardWidth, setCurrentCardWidth] = (0, $42omo.useState)(0);
    const dimensions = getItemDimensions ? getItemDimensions() : cardDimensions;
    /*
	 * Width observer rounds the width of the container (currentCardsGridWidth) returning a whole number.
	 * This means in situations that the width is rounded up, we have an edge case where we are
	 * making calculations with a grid width larger than what we actually have leading to layout issues.
	 *
	 * It is better to adjust the width we get from the observer down (-.5px) and
	 * have some cases where we have extra space (<=.5px) than the latter problem that causes layout issues.
	 */ const currentCardsGridWidthAdjustedForRounding = currentCardsGridWidth - 0.5;
    const numberOfCardsPerRow = Math.floor((currentCardsGridWidthAdjustedForRounding + $fea56e716edbc72a$export$1a197eb476b94cd9) / (dimensions.minWidth + $fea56e716edbc72a$export$1a197eb476b94cd9));
    const maxNumberOfCardsPerRow = Math.min(numberOfCardsPerRow, $fea56e716edbc72a$var$MAX_NUMBER_OF_ITEMS_PER_ROW);
    if (currentCardsGridWidthAdjustedForRounding <= dimensions.minWidth) return {
        calculations: {
            cardWidthOnFullRow: dimensions.minWidth,
            isFirstRowFull: true,
            isFirstRowOverflown: false,
            isGridSmallerOrEqualWidthToCards: true,
            gaps: {
                spaceBetweenCards: $fea56e716edbc72a$export$1a197eb476b94cd9,
                paddingRightGapOffset: 0
            },
            maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
        },
        setCurrentCardsGridWidth: setCurrentCardsGridWidth,
        setCurrentCardWidth: setCurrentCardWidth
    };
    const maxCardSizeOnFullRow = Math.floor((currentCardsGridWidthAdjustedForRounding - $fea56e716edbc72a$export$1a197eb476b94cd9 * (maxNumberOfCardsPerRow - 1)) / maxNumberOfCardsPerRow);
    const isFirstRowFull = numberOfCards >= maxNumberOfCardsPerRow;
    const isFirstRowOverflown = numberOfCards > maxNumberOfCardsPerRow;
    const cardWidthOnFullRow = Math.min(maxCardSizeOnFullRow, dimensions.maxWidth);
    const cardsOnFirstRow = Math.min(numberOfCards, maxNumberOfCardsPerRow);
    const numberOfRowGaps = Math.max(0, cardsOnFirstRow - 1);
    const extraSpaceInGrid = currentCardsGridWidthAdjustedForRounding - cardsOnFirstRow * currentCardWidth - numberOfRowGaps * $fea56e716edbc72a$export$1a197eb476b94cd9;
    const maxAdditionalSpacePerGapBetweenCards = numberOfRowGaps === 0 ? 0 : Math.min(extraSpaceInGrid / numberOfRowGaps, $fea56e716edbc72a$export$622d6c2ee56322dc - $fea56e716edbc72a$export$1a197eb476b94cd9);
    const spaceBetweenCards = $fea56e716edbc72a$export$1a197eb476b94cd9 + maxAdditionalSpacePerGapBetweenCards;
    const paddingRightGapOffset = !isFirstRowFull ? 0 : (extraSpaceInGrid - numberOfRowGaps * maxAdditionalSpacePerGapBetweenCards) / 2;
    const calculations = {
        cardWidthOnFullRow: cardWidthOnFullRow,
        isFirstRowFull: isFirstRowFull,
        isFirstRowOverflown: isFirstRowOverflown,
        isGridSmallerOrEqualWidthToCards: false,
        gaps: {
            spaceBetweenCards: spaceBetweenCards,
            paddingRightGapOffset: paddingRightGapOffset
        },
        maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
    };
    return {
        calculations: calculations,
        setCurrentCardsGridWidth: setCurrentCardsGridWidth,
        setCurrentCardWidth: setCurrentCardWidth
    };
};
module.exports["useWidthAndSpacingCalculations"] = $fea56e716edbc72a$export$a6443181a5681c94;

});

parcelRegister("ahPKE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $4JDbp = parcelRequire("4JDbp");


var $g3LxX = parcelRequire("g3LxX");


var $4cOi8 = parcelRequire("4cOi8");

const $067bbf2166381c77$export$efa81a508b70a345 = {
    [(0, $4cOi8.Height).SMALL]: {
        minWidth: 221,
        maxWidth: 380,
        height: 72
    },
    [(0, $4cOi8.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 308,
        height: 312
    },
    [(0, $4cOi8.Height).LARGE]: {
        minWidth: 358,
        maxWidth: 640,
        height: 312
    }
};
const $067bbf2166381c77$export$1928c8795f1f40c6 = (cardSize)=>{
    return $067bbf2166381c77$export$efa81a508b70a345[cardSize];
};
const $067bbf2166381c77$var$styles = {
    wrapperStyles: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1rjcv77o _kqswh2mm _2mzuglyw _19pkze3t",
    wrapperWithInlinePadding: "_18zrv77o"
};
const $067bbf2166381c77$export$11b226df951ea813 = ({ children: children, isFirstRowFull: isFirstRowFull, cardWidthOnFullRow: cardWidthOnFullRow, setWidth: setWidth, testId: testId = 'card-wrapper', scrollToCard: scrollToCard, clearScrollToCard: clearScrollToCard, index: index, requestScrollIndex: requestScrollIndex, cardId: cardId, extensionLocalId: extensionLocalId, itemDimensions: itemDimensions, hasInlinePadding: hasInlinePadding = false, ariaRole: ariaRole })=>{
    const cardRef = (0, $42omo.useRef)(null);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId }] = (0, $g3LxX.useExtensionsState)();
    const cardDimensions = itemDimensions;
    (0, $42omo.useEffect)(()=>{
        const scrollIntoViewBehavior = {
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        };
        if (cardRef.current) {
            // Scroll to this card as long as its config panel is open OR no config panel is open.
            // If no config panel is open, that covers the case in edit mode where user has clicked
            // scroll buttons on a row-oriented cards instance which they aren't actively editing.
            if (scrollToCard && (!selectedExtensionLocalId || extensionLocalId === selectedExtensionLocalId)) {
                cardRef.current.scrollIntoView(scrollIntoViewBehavior); // Clear scrollIndex to prevent re-invoking scroll effect later unexpectedly
                clearScrollToCard();
            } // Handle the case where user has selected this card to edit from the config panel.
            if (selectedToEditCardId && selectedToEditCardId === cardId && extensionLocalId === selectedExtensionLocalId) // Now that we've reached the right card that user is selecting to edit,
            // trigger the scrolling hook to recalculate scroll window and index so
            // that we can rerender invoking the scroll effect
            requestScrollIndex(index);
            else if (!selectedToEditCardId) // if no card is selected to edit, set index to -1 indicate that it is not currently being used
            requestScrollIndex(-1);
        }
    }, [
        cardRef,
        cardId,
        extensionLocalId,
        index,
        scrollToCard,
        clearScrollToCard,
        selectedExtensionLocalId,
        selectedToEditCardId,
        requestScrollIndex
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        role: ariaRole,
        style: {
            minWidth: isFirstRowFull ? `${cardWidthOnFullRow}px` : `${cardDimensions.minWidth}px`,
            maxWidth: isFirstRowFull ? `${cardWidthOnFullRow}px` : `${cardDimensions.maxWidth}px`
        },
        ref: cardRef,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $067bbf2166381c77$var$styles.wrapperStyles,
            hasInlinePadding && $067bbf2166381c77$var$styles.wrapperWithInlinePadding
        ]),
        children: [
            children,
            index === 0 && setWidth && /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.WidthObserver), {
                setWidth: setWidth,
                offscreen: true
            })
        ]
    });
};
module.exports["CardOrientationWrapper"] = $067bbf2166381c77$export$11b226df951ea813;

});

parcelRegister("fZitC", function(module, exports) {
const $51296ea8f82bf4e5$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $51296ea8f82bf4e5$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (_m, r, g, b)=>r + r + g + g + b + b);
const $51296ea8f82bf4e5$var$rgbFromHex = (input)=>{
    const fullHex = $51296ea8f82bf4e5$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $51296ea8f82bf4e5$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $51296ea8f82bf4e5$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $51296ea8f82bf4e5$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $51296ea8f82bf4e5$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $51296ea8f82bf4e5$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $51296ea8f82bf4e5$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $51296ea8f82bf4e5$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $51296ea8f82bf4e5$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $51296ea8f82bf4e5$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $51296ea8f82bf4e5$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $51296ea8f82bf4e5$var$rgbToLch = (rgb)=>$51296ea8f82bf4e5$var$labToLch($51296ea8f82bf4e5$var$xyzToLab($51296ea8f82bf4e5$var$rgbToXyz(rgb)));
const $51296ea8f82bf4e5$var$lchToRgb = (lch)=>$51296ea8f82bf4e5$var$xyzToRgb($51296ea8f82bf4e5$var$labToXyz($51296ea8f82bf4e5$var$lchToLab(lch)));
const $51296ea8f82bf4e5$export$f38e45b0889fb431 = (hexColor)=>{
    const rgb = $51296ea8f82bf4e5$var$rgbFromHex(hexColor);
    if (rgb === null) return undefined;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $51296ea8f82bf4e5$var$rgbToLch(rgb);
    return lch.l;
};
const $51296ea8f82bf4e5$var$modifyLightness = (hexColor, percent, getShouldModifyLightness)=>{
    const rgb = $51296ea8f82bf4e5$var$rgbFromHex(hexColor);
    if (rgb === null) return hexColor;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $51296ea8f82bf4e5$var$rgbToLch(rgb);
    if (getShouldModifyLightness(lch.l)) lch.l = $51296ea8f82bf4e5$var$clamp(percent, 0, 100);
    return $51296ea8f82bf4e5$var$rgbToHex($51296ea8f82bf4e5$var$lchToRgb(lch));
};
const $51296ea8f82bf4e5$export$5ec9a60e757390f1 = (hexColor, capPercent)=>{
    return $51296ea8f82bf4e5$var$modifyLightness(hexColor, capPercent, (lightnessValue)=>lightnessValue > capPercent);
};
const $51296ea8f82bf4e5$export$16d9f224c1d58542 = (hexColor, minPercent)=>{
    return $51296ea8f82bf4e5$var$modifyLightness(hexColor, minPercent, (lightnessValue)=>lightnessValue < minPercent);
};
module.exports["getLightnessPercentage"] = $51296ea8f82bf4e5$export$f38e45b0889fb431;
module.exports["reduceLightness"] = $51296ea8f82bf4e5$export$5ec9a60e757390f1;
module.exports["increaseLightness"] = $51296ea8f82bf4e5$export$16d9f224c1d58542;

});

parcelRegister("aPwHF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fOKpq = parcelRequire("fOKpq");

const $fbac79744aa5216e$export$9e87ed1f12141293 = (cardId, link, onCardSucceeded, onCardFailed)=>{
    const [isResolved, setIsResolved] = (0, $42omo.useState)(false);
    const [errorCardStatus, setErrorCardStatus] = (0, $42omo.useState)('');
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const shouldPreserveErrorStatus = (0, $42omo.useRef)(false);
    // Other error types [`errored`, `fallback`] should not be caught. We will let the card UI render, even though
    // the SmartCard cannot fetch data for them
    const isRestricted = errorCardStatus === 'forbidden';
    const isUnauthorized = errorCardStatus === 'unauthorized';
    const isNoResult = errorCardStatus === 'not_found';
    (0, $42omo.useEffect)(()=>{
        setErrorCardStatus('');
    }, [
        link,
        setErrorCardStatus
    ]);
    const failExperienceAndSendErrorMonitoring = (0, $42omo.useCallback)((err)=>{
        onCardFailed(err);
        submitError?.(err);
    }, [
        onCardFailed,
        submitError
    ]);
    const trackAndCategorizeError = (0, $42omo.useCallback)(({ status: status, err: err })=>{
        setErrorCardStatus(status);
        setIsResolved(true);
        if (status === 'unauthorized') shouldPreserveErrorStatus.current = true;
        if (err) failExperienceAndSendErrorMonitoring(err);
        else onCardSucceeded(cardId);
    }, [
        setErrorCardStatus,
        cardId,
        onCardSucceeded,
        failExperienceAndSendErrorMonitoring
    ]);
    const trackSuccess = (0, $42omo.useCallback)(()=>{
        onCardSucceeded(cardId);
        setIsResolved(true);
        // For Smart Cards with an unauthorized state, it calls onResolve, but we don't want to clear the error status.
        // shouldPreserveErrorStatus is used b/c we need to skip clearing the error status for one cycle
        if (shouldPreserveErrorStatus.current) {
            shouldPreserveErrorStatus.current = false;
            return;
        }
        setErrorCardStatus('');
    }, [
        setErrorCardStatus,
        cardId,
        onCardSucceeded
    ]);
    return {
        isNoResult: isNoResult,
        isRestricted: isRestricted,
        isUnauthorized: isUnauthorized,
        errorCardStatus: errorCardStatus,
        isResolved: isResolved,
        trackAndCategorizeError: trackAndCategorizeError,
        trackSuccess: trackSuccess
    };
};
module.exports["useTrackedSmartCardState"] = $fbac79744aa5216e$export$9e87ed1f12141293;

});

parcelRegister("hjUk0", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $inPa6 = parcelRequire("inPa6");


var $eyWa4 = parcelRequire("eyWa4");


var $4A7Gn = parcelRequire("4A7Gn");

var $0DTaW = parcelRequire("0DTaW");

var $d2kvf = parcelRequire("d2kvf");


var $8eOJy = parcelRequire("8eOJy");


var $9kLHx = parcelRequire("9kLHx");

const $2557fa1f3f1be3a7$var$tabsListStyles = null;
const $2557fa1f3f1be3a7$export$1f2189c52356e986 = ({ source: source, tabSections: tabSections, onTabClick: onTabClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleTabClick = (0, $42omo.useCallback)((index)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'tab',
                actionSubjectId: 'configPanelNavigationPills',
                source: source,
                attributes: {
                    selectedValue: tabSections[index].value
                }
            }
        }).fire();
        onTabClick?.(tabSections[index]);
    }, [
        createAnalyticsEvent,
        tabSections,
        source,
        onTabClick
    ]);
    const configPanelRef = (0, $42omo.useRef)(null); // Focus the first tab when the config panel opens
    (0, $42omo.useEffect)(()=>{
        if (configPanelRef.current) {
            const firstTab = configPanelRef.current.querySelector('[role="tab"]');
            if (firstTab) firstTab.focus();
        }
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $4A7Gn.default), {
        id: `${source}-config-panel-tabs`,
        onChange: handleTabClick,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: configPanelRef,
                className: (0, $gMc0m.default)([
                    "_n3tdv47k _1e8o1b66 _k88nn7od _1rxjn7od _1d96n7od _v229n7od"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $0DTaW.default), {
                    children: tabSections.map((tab, index)=>{
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $9kLHx.PillTab), {
                            label: tab.label
                        }, index);
                    })
                })
            }),
            tabSections.map((tab, index)=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $d2kvf.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                        grow: "fill",
                        testId: "tab-panel-content",
                        children: tab.tabContent.map((section)=>section.defaultIsExpanded !== undefined && section.title ? /*#__PURE__*/ (0, $l998X.jsx)((0, $8eOJy.CollapsibleItem), {
                                title: section.title,
                                section: section.sectionId,
                                defaultIsExpanded: section?.defaultIsExpanded,
                                source: source,
                                children: section.component
                            }, section.sectionId) : /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                                children: section.component
                            }, section.sectionId))
                    })
                }, index);
            })
        ]
    });
};
module.exports["ConfigPanelGrouping"] = $2557fa1f3f1be3a7$export$1f2189c52356e986;

});

parcelRegister("8eOJy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $bUlM5 = parcelRequire("bUlM5");

var $2W0qg = parcelRequire("2W0qg");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");

const $8c98457c9c23568d$var$pressableStyles = (0, $ecnYn.xcss)({
    background: 'none',
    height: 'space.300',
    paddingInline: 'space.100',
    paddingBlock: 'space.200'
});
const $8c98457c9c23568d$var$wrapperStyles = (0, $ecnYn.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $8c98457c9c23568d$var$expandedContainerStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.200',
    paddingInline: 'space.100'
});
const $8c98457c9c23568d$export$1df80d75edaa7a50 = ({ title: title, defaultIsExpanded: defaultIsExpanded, section: section, children: children, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(defaultIsExpanded ?? false);
    const handleSectionClickAnalytics = (0, $42omo.useCallback)((newState, section)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'collapsible',
                actionSubjectId: 'configPanelSectionCollapsible',
                source: source,
                attributes: {
                    section: section,
                    action: newState ? 'expanded' : 'collapsed'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const handleClick = ()=>{
        handleSectionClickAnalytics(!isExpanded, section);
        setIsExpanded(!isExpanded);
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        space: "space.100",
        xcss: $8c98457c9c23568d$var$wrapperStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
                onClick: handleClick,
                xcss: $8c98457c9c23568d$var$pressableStyles,
                testId: "collapsible-item",
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                            size: "medium",
                            weight: "semibold",
                            children: title
                        }),
                        isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                            label: "",
                            color: "var(--ds-icon, #292A2E)",
                            size: "small"
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            label: "",
                            color: "var(--ds-icon, #292A2E)",
                            size: "small"
                        })
                    ]
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
                space: "space.100",
                xcss: $8c98457c9c23568d$var$expandedContainerStyles,
                children: children
            })
        ]
    });
};
module.exports["CollapsibleItem"] = $8c98457c9c23568d$export$1df80d75edaa7a50;

});

parcelRegister("9kLHx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $bDrnk = parcelRequire("bDrnk");

const $85e70ef54f4ca0cf$var$baseStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    background: "var(--ds-background-neutral, #0515240F)",
    border: `${"var(--ds-border-width, 1px)"} solid transparent`,
    borderRadius: 'radius.full',
    gap: 'space.100',
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    paddingInline: 'space.150'
});
const $85e70ef54f4ca0cf$var$selectedStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    background: "var(--ds-background-selected, #E9F2FE)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-selected, #1868DB)"}`,
    borderRadius: 'radius.full',
    color: 'color.text.selected',
    gap: 'space.100',
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    paddingInline: 'space.150'
});
const $85e70ef54f4ca0cf$export$78d15021d44428c = ({ label: label })=>{
    const tabAttributes = (0, $bDrnk.default)();
    const isTabSelected = tabAttributes['aria-selected'];
    const { 'aria-controls': _ariaControls, ...tabAttributesWithoutControls } = tabAttributes;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: isTabSelected ? $85e70ef54f4ca0cf$var$selectedStyles : $85e70ef54f4ca0cf$var$baseStyles,
        ...tabAttributesWithoutControls,
        role: "tab",
        children: label
    });
};
module.exports["PillTab"] = $85e70ef54f4ca0cf$export$78d15021d44428c;

});

parcelRegister("FjHnq", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8aNCk = parcelRequire("8aNCk");


var $BhFQp = parcelRequire("BhFQp");

const $99266c3e40a077c6$export$4c99a519d851f90c = /*#__PURE__*/ (0, $42omo.forwardRef)(function DragHandleButton({ label: label, ...buttonProps }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $BhFQp.DragHandleButtonBase), {
        ref: ref,
        ...buttonProps,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8aNCk))), {
            spacing: "spacious",
            label: label,
            size: "small"
        })
    });
});
module.exports["DragHandleButton"] = $99266c3e40a077c6$export$4c99a519d851f90c;

});

parcelRegister("BhFQp", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $dOMrE = parcelRequire("dOMrE");

function $428e284101874428$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Cannot use `@atlaskit/button` here because it cancels `mousedown` events
 * which prevents dragging.
 */ const $428e284101874428$var$buttonStyles = {
    name: "txaqq0",
    styles: "color:var(--ds-text, #292A2E);border-radius:var(--ds-radius-small, 4px);padding:var(--ds-space-0, 0px);width:max-content;border:none;cursor:grab;display:flex"
};
const $428e284101874428$var$buttonAppearanceStyles = {
    default: {
        name: "1m0qggu",
        styles: "background-color:var(--ds-background-neutral, #0515240F);&:hover{background-color:var(--ds-background-neutral-hovered, #0B120E24);}&:active{background-color:var(--ds-background-neutral-pressed, #080F214A);}"
    },
    subtle: {
        name: "u8pb1t",
        styles: "background-color:var(--ds-background-neutral-subtle, #00000000);&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #0B120E24);}"
    },
    selected: {
        name: "1km59x1",
        styles: "background-color:var(--ds-background-selected, #E9F2FE);color:var(--ds-text-selected, #1868DB)"
    }
};
const $428e284101874428$export$c099c65cfbd84d0a = /*#__PURE__*/ (0, $42omo.forwardRef)(function DragHandleButton({ children: children, isSelected: isSelected = false, testId: testId, appearance: appearanceProp = 'default', type: /**
   * Defaulting to `button` instead of `submit` (native default in some cases).
   *
   * A type of `submit` only makes sense in a form context, and isn't very
   * relevant to a drag handle.
   *
   * `@atlaskit/button` also defaults to a type of `button` as well, as it
   * is more semantically appropriate in a wider range of cases.
   */ type = 'button', ...buttonProps }, ref) {
    const appearance = isSelected ? 'selected' : appearanceProp;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dOMrE.default), null, /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
        ref: ref,
        css: [
            $428e284101874428$var$buttonStyles,
            $428e284101874428$var$buttonAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        type: type,
        ...buttonProps
    }, children));
});
module.exports["DragHandleButtonBase"] = $428e284101874428$export$c099c65cfbd84d0a;

});

parcelRegister("7Ux0V", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fQWPs = parcelRequire("fQWPs");

const $a249d56289792314$export$740dd80d7ba80184 = (backgroundColor, isReadableForegroundColor, foregroundColor, updateForegroundColor, defaultParameters)=>{
    (0, $42omo.useEffect)(()=>{
        // No need to do autotransition when background color is same as default BackgroundColor, e.g. theme color
        if (!isReadableForegroundColor(foregroundColor) && backgroundColor !== defaultParameters?.backgroundColor) {
            const textColorToken = (0, $fQWPs.extractToken)(foregroundColor);
            if (textColorToken === (0, $fQWPs.extractToken)("var(--ds-text, #292A2E)")) updateForegroundColor("var(--ds-text-inverse, #FFFFFF)");
            else if (textColorToken === (0, $fQWPs.extractToken)("var(--ds-text-inverse, #FFFFFF)")) updateForegroundColor("var(--ds-text, #292A2E)");
            else if (foregroundColor === defaultParameters?.textColor) {
                if (isReadableForegroundColor("var(--ds-text, #292A2E)")) updateForegroundColor("var(--ds-text, #292A2E)");
                else updateForegroundColor("var(--ds-text-inverse, #FFFFFF)");
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        backgroundColor
    ]);
};
module.exports["useAutoTransitioningColors"] = $a249d56289792314$export$740dd80d7ba80184;

});

parcelRegister("aPCur", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $hiS1z = parcelRequire("hiS1z");

var $1cfRh = parcelRequire("1cfRh");


var $1Whri = parcelRequire("1Whri");


var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $3gadb = parcelRequire("3gadb");


var $4K9rx = parcelRequire("4K9rx");


var $4VyWY = parcelRequire("4VyWY");


var $4gY0b = parcelRequire("4gY0b");

const $4c5fe77c591c2edb$var$styles = {
    borderOptionContainer: "_1rjcv77o _18zr1b66 _bfhk1j9a _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1tcg _1bsb1tcg",
    border: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1",
    selected: "_1h6d1w55 _bfhk15s3"
};
const $4c5fe77c591c2edb$export$b2197740663fbf1 = ({ cornerStyleValue: cornerStyleValue, updateCornerStyle: updateCornerStyle, roundCornerValue: roundCornerValue, squareCornerValue: squareCornerValue })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const handleCornerOptionClick = (cornerOption)=>updateCornerStyle(cornerOption);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        spread: "space-between",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "color.text",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                    ...(0, $4gY0b.messages).cornerStyle
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                space: "space.100",
                alignBlock: "center",
                children: [
                    {
                        cornerOption: roundCornerValue,
                        IconComponent: (0, $4K9rx.RoundCornerIcon),
                        label: (0, $4gY0b.messages).roundCornerStyleLabel
                    },
                    {
                        cornerOption: squareCornerValue,
                        IconComponent: (0, $4VyWY.SharpCornerIcon),
                        label: (0, $4gY0b.messages).squareCornerStyleLabel
                    }
                ].map(({ cornerOption: cornerOption, IconComponent: IconComponent, label: label })=>{
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                        content: formatMessage(label),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                            xcss: (0, $1Whri.cx)($4c5fe77c591c2edb$var$styles.borderOptionContainer, $4c5fe77c591c2edb$var$styles.border, cornerStyleValue === cornerOption && $4c5fe77c591c2edb$var$styles.selected),
                            onClick: ()=>handleCornerOptionClick(cornerOption),
                            testId: `${cornerOption}${cornerStyleValue === cornerOption ? '--selected' : ''}`,
                            children: /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
                                color: cornerStyleValue === cornerOption ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon, #292A2E)",
                                label: formatMessage(label)
                            })
                        })
                    }, cornerOption);
                })
            })
        ]
    });
};
module.exports["CornerStyleConfig"] = $4c5fe77c591c2edb$export$b2197740663fbf1;

});

parcelRegister("4gY0b", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $772b9aa8dda76a10$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    cornerStyle: {
        id: "company-hub.company-hub-common.links-menu.corner.style",
        defaultMessage: "Corner style"
    },
    roundCornerStyleLabel: {
        id: "company-hub.company-hub-common.links-menu.corner.style-round",
        defaultMessage: "Round"
    },
    squareCornerStyleLabel: {
        id: "company-hub.company-hub-common.links-menu.corner.style-square",
        defaultMessage: "Square"
    }
});
module.exports["messages"] = $772b9aa8dda76a10$export$defe85febe8b728c;

});

parcelRegister("jZuqn", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $4kjfc = parcelRequire("4kjfc");

const $62e9909ce239e1d8$var$packageName = "platform-pkg";
const $62e9909ce239e1d8$var$packageVersion = "0.0.0-use.local";
const $62e9909ce239e1d8$var$progressIndicatorGapMap = {
    comfortable: {
        default: 'space.100',
        large: 'space.150'
    },
    cozy: {
        default: 'space.075',
        large: 'space.100'
    },
    compact: {
        default: 'space.050',
        large: 'space.075'
    }
};
const $62e9909ce239e1d8$var$sizes = {
    default: 8,
    large: 12
};
const $62e9909ce239e1d8$var$varDotsSize = '--ds-dots-size';
const $62e9909ce239e1d8$var$varDotsMargin = '--ds-dots-margin';
/**
 * __ProgressDots__
 *
 * A progress indicator shows the user where they are along the steps of a journey.
 */ const $62e9909ce239e1d8$var$ProgressDots = ({ appearance: appearance = 'default', ariaControls: ariaControls = 'panel', ariaLabel: ariaLabel = 'tab', size: size = 'default', // NOTE: `spacing` is a reserved HTML attribute and will be added to the
// element, replaced with `gutter`.
spacing: gutter = 'comfortable', selectedIndex: selectedIndex, testId: testId, values: values, onSelect: onSelect })=>{
    const tablistRef = (0, $42omo.useRef)(null);
    const onSelectWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onSelect || (0, $ee7An.default),
        action: 'selected',
        componentName: 'progressIndicator',
        packageName: $62e9909ce239e1d8$var$packageName,
        packageVersion: $62e9909ce239e1d8$var$packageVersion
    });
    const gap = $62e9909ce239e1d8$var$progressIndicatorGapMap[gutter][size];
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        const indicators = Array.from(tablistRef.current.children);
        // bail if the target isn't an indicator
        if (!indicators.includes(event.target)) return;
        // bail if not valid arrow key
        const isLeft = event.key === 'ArrowLeft';
        const isRight = event.key === 'ArrowRight';
        if (!isLeft && !isRight) return;
        // bail if at either end of the values
        const isAlpha = isLeft && selectedIndex === 0;
        const isOmega = isRight && selectedIndex === values.length - 1;
        if (isAlpha || isOmega) return;
        const index = isLeft ? selectedIndex - 1 : selectedIndex + 1;
        // call the consumer's select method and focus the applicable indicator
        if (onSelect) onSelectWithAnalytics({
            event: event,
            index: index
        });
        if (typeof indicators[index].focus === 'function') indicators[index].focus();
    }, [
        onSelectWithAnalytics,
        selectedIndex,
        values,
        onSelect
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!onSelect) return 0, $ee7An.default;
        return (0, $fFa3V.bind)(document, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: false
            }
        });
    }, [
        onSelect,
        handleKeyDown
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        style: {
            [$62e9909ce239e1d8$var$varDotsSize]: `${$62e9909ce239e1d8$var$sizes[size]}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$62e9909ce239e1d8$var$varDotsMargin]: gap
        },
        role: onSelect && 'tablist',
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            testId: testId,
            ref: (r)=>{
                tablistRef.current = r;
            },
            alignInline: "center",
            space: gap,
            children: values.map((_, index)=>{
                const isSelected = selectedIndex === index;
                const tabId = `${ariaLabel}${index}`;
                const panelId = `${ariaControls}${index}`;
                const indicatorTestId = testId && `${testId}-ind-${index}`;
                return onSelect ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4kjfc.ButtonIndicator), {
                    testId: indicatorTestId,
                    appearance: appearance,
                    isSelected: isSelected,
                    tabId: tabId,
                    panelId: panelId,
                    onClick: (event)=>onSelectWithAnalytics({
                            event: event,
                            index: index
                        })
                }, index) : /*#__PURE__*/ (0, $l998X.jsx)((0, $4kjfc.PresentationalIndicator), {
                    testId: indicatorTestId,
                    appearance: appearance,
                    isSelected: isSelected
                }, index);
            })
        })
    });
};
var $62e9909ce239e1d8$export$2e2bcd8739ae039 = $62e9909ce239e1d8$var$ProgressDots;
module.exports["default"] = $62e9909ce239e1d8$export$2e2bcd8739ae039;

});

parcelRegister("4kjfc", function(module, exports) {
/* indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");


var $6F6hl = parcelRequire("6F6hl");

const $ab0fca144a05f4f5$var$commonStyles = {
    common: "_2rko1rr0 _1bsbg7kr _4t3ig7kr _kqswh2mm _cfu11ule _1mp41th6 _kfgt1th6 _1cs8stnw _1kt9b3bt _iajm1yh4 _z5wt1yh4"
};
const $ab0fca144a05f4f5$var$colorBorderMap = {
    default: "_19it1axi",
    help: "_19it1axi",
    inverted: "_19it1ps9",
    primary: "_19it1axi"
};
const $ab0fca144a05f4f5$var$buttonStyle = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80omtlke"
};
const $ab0fca144a05f4f5$var$backgroundColor = (isSelected)=>{
    if (!isSelected) return {
        default: "var(--ds-surface, #FFFFFF)",
        help: "var(--ds-surface, #FFFFFF)",
        inverted: "var(--ds-background-neutral-subtle, #00000000)",
        primary: "var(--ds-surface, #FFFFFF)"
    };
    return {
        default: "var(--ds-icon, #292A2E)",
        help: "var(--ds-icon-discovery, #AF59E1)",
        inverted: "var(--ds-icon-inverse, #FFFFFF)",
        primary: "var(--ds-icon-brand, #1868DB)"
    };
};
const $ab0fca144a05f4f5$export$ec3c81af58a0c4e7 = ({ appearance: appearance, isSelected: isSelected, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: testId,
        // here we set it dynamic because that backgroundColor and xcss don't support the colors we need here eg. token('color.icon')
        style: {
            backgroundColor: $ab0fca144a05f4f5$var$backgroundColor(isSelected)[appearance]
        },
        xcss: (0, $1bHXt.cx)($ab0fca144a05f4f5$var$commonStyles.common, $ab0fca144a05f4f5$var$colorBorderMap[appearance])
    });
};
const $ab0fca144a05f4f5$export$3716cb524d6018c1 = ({ appearance: appearance, panelId: panelId, tabId: tabId, isSelected: isSelected, onClick: onClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        role: "tab",
        style: {
            backgroundColor: $ab0fca144a05f4f5$var$backgroundColor(isSelected)[appearance]
        },
        xcss: (0, $1bHXt.cx)($ab0fca144a05f4f5$var$commonStyles.common, $ab0fca144a05f4f5$var$buttonStyle.root, $ab0fca144a05f4f5$var$colorBorderMap[appearance]),
        "aria-controls": panelId,
        "aria-selected": isSelected,
        id: tabId,
        onClick: onClick,
        tabIndex: isSelected ? -1 : undefined,
        testId: testId,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
            children: tabId
        })
    });
};
module.exports["PresentationalIndicator"] = $ab0fca144a05f4f5$export$ec3c81af58a0c4e7;
module.exports["ButtonIndicator"] = $ab0fca144a05f4f5$export$3716cb524d6018c1;

});

parcelRegister("4kqHy", function(module, exports) {

var $5Ac5G = parcelRequire("5Ac5G");


var $4cOi8 = parcelRequire("4cOi8");

var $9Uxg8 = parcelRequire("9Uxg8");

const $e444a9965bda56a8$export$9c475d9878794e1e = {
    size: 'medium',
    isPublishDateShown: false,
    isAvatarShown: true,
    isSegmentationShown: false,
    extensionTitle: 'Carousel',
    version: '1',
    cards: []
};
const $e444a9965bda56a8$export$5b30186b049eeb53 = [
    {
        cardId: '1',
        title: 'Improving Pipeline Stability: Cypress Test Isolation',
        link: 'https://www.atlassian.com/continuous-delivery/software-testing',
        description: 'desc 1',
        imageSrc: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&q=80&w=1080',
        imageAltText: 'green mountain across body of water',
        backgroundColor: 'var(--ds-background-input, #FFFFFF)',
        buttonStyle: (0, $4cOi8.ButtonStyle).DEFAULT,
        buttonText: '',
        layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT,
        textColor: 'var(--ds-text, #172B4D)'
    },
    {
        cardId: '2',
        title: 'Pug link',
        link: 'https://pug.jira-dev.com/wiki/spaces/CFE/blog/2023/11/28/452982538475/Sweet-State+Sweeter+APIs',
        description: 'desc 2',
        imageSrc: 'some-source-2.com',
        imageAltText: 'Luminous urban glow',
        backgroundColor: 'var(--ds-background-input, #FFFFFF)',
        buttonStyle: (0, $4cOi8.ButtonStyle).DEFAULT,
        buttonText: '',
        layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT,
        textColor: 'var(--ds-text, #172B4D)'
    },
    {
        cardId: '3',
        title: 'Connie',
        link: 'https://www.atlassian.com/software/confluence',
        description: 'Some description text to tell the viewer a little bit about the documentation.',
        imageSrc: 'https://images.unsplash.com/photo-1580100586938-02822d99c4a8?auto=format&fit=crop&q=80&w=1080',
        imageAltText: 'body of water near mountain during daytime',
        backgroundColor: 'var(--ds-background-input, #FFFFFF)',
        buttonStyle: (0, $4cOi8.ButtonStyle).DEFAULT,
        buttonText: '',
        layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT,
        textColor: 'var(--ds-text, #172B4D)'
    }
];
const $e444a9965bda56a8$export$b51ee9bed3eac079 = {
    [(0, $4cOi8.ITEM_FIELDS).CARD_ID]: 'frame-001',
    [(0, $4cOi8.ITEM_FIELDS).LINK]: 'https://www.atlassian.com/continuous-delivery/software-testing',
    [(0, $4cOi8.ITEM_FIELDS).IS_LINK_USER_EDITED]: true,
    [(0, $4cOi8.ITEM_FIELDS).TITLE]: 'Welcome to Our Site',
    [(0, $4cOi8.ITEM_FIELDS).IS_TITLE_USER_EDITED]: false,
    [(0, $4cOi8.ITEM_FIELDS).DESCRIPTION]: 'An introduction to what we do.',
    [(0, $4cOi8.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED]: true,
    [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: 'https://images.unsplash.com/photo-1488470015861-8bb1317353ef?auto=format&fit=crop&q=80&w=1080',
    [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: 'People collaborating in an office',
    [(0, $4cOi8.ITEM_FIELDS).CONFLUENCE_PAGE_ID]: '12345',
    [(0, $4cOi8.ITEM_FIELDS).BACKGROUND_COLOR]: "var(--ds-surface-overlay, #FFFFFF)",
    [(0, $4cOi8.ITEM_FIELDS).TEXT_COLOR]: "var(--ds-text, #292A2E)",
    [(0, $4cOi8.ITEM_FIELDS).LAYOUT]: (0, $4cOi8.CommonLayout).FRAME_ABOVE_IMAGE,
    [(0, $4cOi8.ITEM_FIELDS).BUTTON_TEXT]: 'mockButtonText',
    [(0, $4cOi8.ITEM_FIELDS).BUTTON_STYLE]: (0, $4cOi8.ButtonStyle).DEFAULT
};
const $e444a9965bda56a8$export$15eb9febd104355b = (parameters)=>({
        content: null,
        extensionKey: (0, $5Ac5G.carouselExtensionKey),
        extensionType: (0, $5Ac5G.carouselExtensionType),
        localId: 'local-123',
        parameters: parameters,
        type: 'extension'
    });
const $e444a9965bda56a8$export$5b81623830690b3a = {
    extensionTitle: 'Carousel',
    cards: $e444a9965bda56a8$export$5b30186b049eeb53,
    version: '2',
    cornerStyle: (0, $4cOi8.CornerStyle).ROUNDED,
    isAutoplayEnabled: false,
    navigationStyle: (0, $9Uxg8.NavigationStyle).THUMBNAILS
};
const $e444a9965bda56a8$export$e24c2394a5c287c8 = {
    size: 'small',
    extensionTitle: 'Carousel',
    cards: [
        {
            cardId: '12345',
            link: '',
            title: '',
            description: '',
            imageSrc: 'https://images.unsplash.com/some-flower-pic',
            imagePosition: 'middle',
            imageAltText: 'orange petaled flowers'
        },
        {
            cardId: '123456',
            link: '',
            title: '',
            description: 'Cpslkfjlsdjfksldfjklsdjfsdkfsjlfksldflskjdfklsdjfkls lskdjfljk skfdlj',
            imageSrc: 'https://images.unsplash.com/some-flower-pic',
            imagePosition: 'middle',
            imageAltText: 'orange petaled flowers'
        },
        {
            cardId: '1234567',
            link: '',
            title: 'Very nice',
            description: '',
            imageSrc: 'https://images.unsplash.com/some-flower-pic',
            imagePosition: 'middle',
            imageAltText: 'orange petaled flowers'
        }
    ],
    isPublishDateShown: false,
    isAvatarShown: false,
    isSegmentationShown: false,
    version: '1',
    renderVariant: undefined
};
const $e444a9965bda56a8$export$25f38bdb8e927bfc = {
    extensionTitle: 'Carousel',
    cards: [
        {
            cardId: '12345',
            link: 'google.com',
            title: 'Company News',
            description: 'Visit the link below to check out latest company news',
            imageSrc: 'https://images.unsplash.com/some-flower-pic',
            imageAltText: 'orange petaled flowers',
            backgroundColor: '#f2f9ff',
            textColor: 'var(--ds-text)',
            layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT,
            buttonText: 'View news',
            buttonStyle: (0, $4cOi8.ButtonStyle).ALTERNATIVE_1
        },
        {
            cardId: '123456',
            link: '',
            title: 'Reminder about mandatory trainings',
            description: 'Cpslkfjlsdjfksldfjklsdjfsdkfsjlfksldflskjdfklsdjfkls lskdjfljk skfdlj',
            imageSrc: 'https://images.unsplash.com/some-flower-pic',
            imageAltText: 'orange petaled flowers',
            backgroundColor: '#f1f1ff',
            textColor: 'var(--ds-text)',
            layout: (0, $4cOi8.CommonLayout).NO_IMAGE_BACKGROUND
        },
        {
            cardId: '1234567',
            link: '',
            title: 'Very nice',
            description: '',
            imageSrc: 'https://images.unsplash.com/photo-1580100586938-02822d99c4a8?auto=format&fit=crop&q=80&w=1080',
            imageAltText: 'orange petaled flowers',
            layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_LEFT
        },
        {
            cardId: '1234567',
            link: '',
            title: 'Very nice',
            description: '',
            imageSrc: 'https://images.unsplash.com/some-flower-pic',
            imageAltText: 'orange petaled flowers'
        },
        ...Array.from({
            length: 7
        }, (_, i)=>({
                cardId: `1234567-${i}`,
                link: '',
                title: `Very nice ${i}`,
                description: '',
                imageSrc: 'https://images.unsplash.com/some-flower-pic',
                imageAltText: 'orange petaled flowers'
            }))
    ],
    version: '3',
    isAutoplayEnabled: false,
    navigationStyle: (0, $9Uxg8.NavigationStyle).PROGRESS_CIRCLES
};
const $e444a9965bda56a8$export$d9af11b83d86b211 = [
    {
        cardId: '1',
        title: 'Improving Pipeline Stability: Cypress Test Isolation',
        link: 'https://www.atlassian.com/continuous-delivery/software-testing',
        description: 'desc 1',
        imageSrc: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&q=80&w=1080',
        imageAltText: 'green mountain across body of water',
        backgroundColor: 'var(--ds-surface)',
        textColor: 'var(--ds-text)',
        layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT
    },
    {
        cardId: '2',
        title: 'Pug link',
        link: 'https://pug.jira-dev.com/wiki/spaces/CFE/blog/2023/11/28/452982538475/Sweet-State+Sweeter+APIs',
        description: 'desc 2',
        imageSrc: 'some-source-2.com',
        imageAltText: 'Luminous urban glow',
        backgroundColor: 'var(--ds-surface)',
        textColor: 'var(--ds-text)',
        layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT
    },
    {
        cardId: '3',
        title: 'Connie',
        link: 'https://www.atlassian.com/software/confluence',
        description: 'Some description text to tell the viewer a little bit about the documentation.',
        imageSrc: 'https://images.unsplash.com/photo-1580100586938-02822d99c4a8?auto=format&fit=crop&q=80&w=1080',
        imageAltText: 'body of water near mountain during daytime',
        backgroundColor: 'var(--ds-surface)',
        textColor: 'var(--ds-text)',
        layout: (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT
    }
];
const $e444a9965bda56a8$export$8506af8f68cbe2c4 = {
    cards: $e444a9965bda56a8$export$5b30186b049eeb53,
    extensionTitle: 'Carousel',
    version: '2',
    cornerStyle: (0, $4cOi8.CornerStyle).ROUNDED,
    isAutoplayEnabled: false,
    navigationStyle: (0, $9Uxg8.NavigationStyle).THUMBNAILS
};
const $e444a9965bda56a8$export$f541d20bb0d082c4 = ()=>{
    return {
        type: 'extension',
        attrs: {
            extensionType: (0, $5Ac5G.carouselExtensionType),
            extensionKey: (0, $5Ac5G.carouselExtensionKey),
            parameters: $e444a9965bda56a8$export$8506af8f68cbe2c4,
            text: null,
            layout: 'default',
            localId: 'some-localId'
        }
    };
};
const $e444a9965bda56a8$export$70ab1ac0ff8cf6ad = {
    type: 'extension',
    attrs: {
        extensionType: (0, $5Ac5G.carouselExtensionType),
        extensionKey: (0, $5Ac5G.carouselExtensionKey),
        parameters: $e444a9965bda56a8$export$8506af8f68cbe2c4,
        text: null,
        layout: 'default',
        localId: 'some-localId'
    }
};
module.exports["getExtensionNodeFromParams"] = $e444a9965bda56a8$export$15eb9febd104355b;
module.exports["mockInitialCarouselParameters"] = $e444a9965bda56a8$export$e24c2394a5c287c8;
module.exports["mockV2Carousel10FramesParameters"] = $e444a9965bda56a8$export$25f38bdb8e927bfc;

});

parcelRegister("luzTT", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4cOi8 = parcelRequire("4cOi8");

var $1Yx9c = parcelRequire("1Yx9c");

var $fOKpq = parcelRequire("fOKpq");


var $45RgY = parcelRequire("45RgY");

const $66f873b0a999f0b6$export$5186613af22c85f5 = ({ extensionNode: extensionNode, contentId: contentId })=>{
    const { parameters: parameters, localId: localId = '' } = extensionNode || {};
    const { isCompanyHub: isCompanyHub } = (0, $fOKpq.useProductDependencies)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1Yx9c.HubExtensionsWrapper), {
        extensionNode: extensionNode,
        contentId: contentId,
        mode: (0, $4cOi8.ExtensionMode).RENDERER,
        showNoDataState: !parameters,
        packageName: "carousel-extension",
        children: parameters && /*#__PURE__*/ (0, $l998X.jsx)((0, $45RgY.CarouselContentV2), {
            extensionLocalId: localId,
            parameters: parameters,
            isInViewMode: true,
            contentId: contentId,
            isCompanyHub: isCompanyHub
        })
    });
};
const $66f873b0a999f0b6$export$144901db2ea8e967 = ({ propsProvider: PropsProvider, extensionNode: extensionNode, contentId: contentId })=>/*#__PURE__*/ (0, $l998X.jsx)(PropsProvider, {
        mode: (0, $4cOi8.ExtensionMode).RENDERER,
        extensionNode: extensionNode,
        contentId: contentId,
        children: /*#__PURE__*/ (0, $l998X.jsx)($66f873b0a999f0b6$export$5186613af22c85f5, {
            extensionNode: extensionNode,
            contentId: contentId
        })
    });
module.exports["Carousel"] = $66f873b0a999f0b6$export$144901db2ea8e967;

});


//# sourceMappingURL=carousel-extension.2935e4b7.js.map
